/* oxlint-disable */
// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addDraftVariants, addSlotSkippedRule, agentsFigmaRun, agentsFigmaRunStream, bulkSaveVariables, bulkUpdateReviewStatus, convertDynamicImageTemplateAsNeonblue, convertFigmaUrlToTemplate, createApiKey, createBrazeIntegration, createCantoIntegration, createContentEvaluationCriteria, createContentRule, createContentRuleGroup, createContentSchema, createContentStyle, createContentTemplate, createContentVariable, createContentVariableType, createDraftComment, createDraftExperiment, createDynamicImageIntegration, createExperiment, createExperimentVariant, createKlaviyoDashboardIntegration, createKlaviyoIntegration, createSnowflakeShareOutboundIntegration, createWarehouseFeatureSpec, createWarehouseIdType, createWarehouseMetric, createWarehouseSourceTable, deleteApiKey, deleteComment, deleteContentAsset, deleteContentEvaluationCriteriaById, deleteContentRule, deleteContentRuleGroup, deleteContentSchemaById, deleteContentStyle, deleteContentTemplateById, deleteContentVariable, deleteContentVariableType, deleteExperiment, deleteIntegration, deleteWarehouseIdType, deleteWarehouseMetric, deleteWarehouseSourceTable, enqueueDraftEvaluation, enqueueDraftGeneration, enqueueRegenerateWithFeedback, enqueueVariantEvaluation, evaluateMarketingContent, executeExperimentMetric, executeWarehouseMetricTimeseries, generate, generateAdversarialContent, generateCombinedAdversarialContent, generateSampleTemplateParameters, generateStream, getActiveStream, getAppUser, getContentAsset, getContentEvaluationCriteriaById, getContentRule, getContentRuleGroup, getContentSchemaById, getContentStyle, getContentTemplateById, getContentVariable, getContentVariableType, getDashboardStats, getDiagnosticsLogEntry, getDraft, getDynamicImageTemplate, getExperimentContext, getExperimentDetails, getExperimentExposuresByDay, getExperimentMetricDailyByVariant, getExperimentMetricTimeseriesDaily, getExperimentVariantEditUrl, getExperimentVariantMetrics, getExperimentVariantReport, getFeedbackPrompt, getFigmaConvertLog, getFigmaConvertSession, getFigmaConvertStatus, getJob, getReportInsights, getReportInsightsAnalysis, getReportInsightsChart, getReportInsightsHypotheses, getReportInsightsRecap, getReportInsightsSummary, getSlotEvalOverrides, getVariantReport, getWarehouseFeatureSpec, getWarehouseIdType, getWarehouseMetric, getWarehouseSourceTable, getWarehouseStore, healthLiveness, healthReadiness, importDynamicImageTemplateAsNeonblue, klaviyoOauthCallback, klaviyoOauthInitiate, listApiKeys, listBatchGenerations, listChatModels, listContentAssets, listContentEvaluationCriteria, listContentRuleGroups, listContentRules, listContentSchemas, listContentStyles, listContentTemplates, listContentVariables, listContentVariableTypes, listDraftGenerations, listDrafts, listDraftVariantComments, listDynamicImageFonts, listDynamicImageTemplates, listDynamicImageTemplateSlices, listExperimentFeatures, listExperimentMetrics, listExperimentMetricsSummary, listExperiments, listExperimentVariants, listFigmaConvertRuns, listIntegrations, listJobs, listSourceTemplates, listSourceTypes, listVariablesForType, listWarehouseFeatureSpecs, listWarehouseIdTypes, listWarehouseMetrics, listWarehouseSourceTables, type Options, previewContentTemplate, previewWarehouseFeature, previewWarehouseMetric, promoteDraftExperiment, queryDiagnosticsLogs, regenerateDraftVariant, removeExperimentVariants, removeSlotSkippedRule, renderContentTemplate, resolveVariableSlugs, resyncDynamicImageTemplateAsNeonblue, root, runAdversarialTest, saveNeonblueTemplate, setDraftCurrentGenerations, setExperimentStatus, setExperimentVariantStatus, shopifyInstall, shopifyOauthCallback, shopifyOauthInitiate, streamDiagnosticsLogs, streamEvaluationByExperiment, streamEvaluationByVariant, streamFigmaConvert, streamGenerationByExperiment, streamRegenerateByVariant, syncContentTemplateFromSource, syncSourceTemplates, updateComment, updateCommentStatus, updateContentAsset, updateContentEvaluationCriteria, updateContentRule, updateContentRuleGroup, updateContentSchema, updateContentStyle, updateContentTemplate, updateContentVariable, updateContentVariableType, updateDraftExperiment, updateDraftVariant, updateDraftVariantReviewStatus, updateExperiment, updateExperimentVariants, updateIntegration, updateWarehouseFeatureSpec, updateWarehouseIdType, updateWarehouseMetric, updateWarehouseSourceTable, uploadImage } from '../sdk.gen';
import type { AddDraftVariantsData, AddDraftVariantsError, AddDraftVariantsResponse2, AddSlotSkippedRuleData, AddSlotSkippedRuleError, AddSlotSkippedRuleResponse, AgentsFigmaRunData, AgentsFigmaRunError, AgentsFigmaRunResponse, AgentsFigmaRunStreamData, AgentsFigmaRunStreamError, BulkSaveVariablesData, BulkSaveVariablesError, BulkSaveVariablesResponse, BulkUpdateReviewStatusData, BulkUpdateReviewStatusError, BulkUpdateReviewStatusResponse, ConvertDynamicImageTemplateAsNeonblueData, ConvertDynamicImageTemplateAsNeonblueError, ConvertDynamicImageTemplateAsNeonblueResponse, ConvertFigmaUrlToTemplateData, ConvertFigmaUrlToTemplateError, ConvertFigmaUrlToTemplateResponse, CreateApiKeyData, CreateApiKeyResponse, CreateBrazeIntegrationData, CreateBrazeIntegrationError, CreateBrazeIntegrationResponse, CreateCantoIntegrationData, CreateCantoIntegrationError, CreateCantoIntegrationResponse, CreateContentEvaluationCriteriaData, CreateContentEvaluationCriteriaError, CreateContentEvaluationCriteriaResponse, CreateContentRuleData, CreateContentRuleError, CreateContentRuleGroupData, CreateContentRuleGroupError, CreateContentRuleGroupResponse, CreateContentRuleResponse, CreateContentSchemaData, CreateContentSchemaError, CreateContentSchemaResponse, CreateContentStyleData, CreateContentStyleError, CreateContentStyleResponse, CreateContentTemplateData, CreateContentTemplateError, CreateContentTemplateResponse, CreateContentVariableData, CreateContentVariableError, CreateContentVariableResponse, CreateContentVariableTypeData, CreateContentVariableTypeError, CreateContentVariableTypeResponse, CreateDraftCommentData, CreateDraftCommentError, CreateDraftCommentResponse, CreateDraftExperimentData, CreateDraftExperimentError, CreateDraftExperimentResponse, CreateDynamicImageIntegrationData, CreateDynamicImageIntegrationError, CreateDynamicImageIntegrationResponse, CreateExperimentData, CreateExperimentError, CreateExperimentResponse, CreateExperimentVariantData, CreateExperimentVariantError, CreateExperimentVariantResponse, CreateKlaviyoDashboardIntegrationData, CreateKlaviyoDashboardIntegrationError, CreateKlaviyoDashboardIntegrationResponse, CreateKlaviyoIntegrationData, CreateKlaviyoIntegrationError, CreateKlaviyoIntegrationResponse, CreateSnowflakeShareOutboundIntegrationData, CreateSnowflakeShareOutboundIntegrationError, CreateSnowflakeShareOutboundIntegrationResponse, CreateWarehouseFeatureSpecData, CreateWarehouseFeatureSpecError, CreateWarehouseFeatureSpecResponse, CreateWarehouseIdTypeData, CreateWarehouseIdTypeError, CreateWarehouseIdTypeResponse, CreateWarehouseMetricData, CreateWarehouseMetricError, CreateWarehouseMetricResponse, CreateWarehouseSourceTableData, CreateWarehouseSourceTableError, CreateWarehouseSourceTableResponse, DeleteApiKeyData, DeleteApiKeyError, DeleteApiKeyResponse, DeleteCommentData, DeleteCommentError, DeleteCommentResponse, DeleteContentAssetData, DeleteContentAssetError, DeleteContentAssetResponse, DeleteContentEvaluationCriteriaByIdData, DeleteContentEvaluationCriteriaByIdError, DeleteContentEvaluationCriteriaByIdResponse, DeleteContentRuleData, DeleteContentRuleError, DeleteContentRuleGroupData, DeleteContentRuleGroupError, DeleteContentRuleGroupResponse, DeleteContentRuleResponse, DeleteContentSchemaByIdData, DeleteContentSchemaByIdError, DeleteContentSchemaByIdResponse, DeleteContentStyleData, DeleteContentStyleError, DeleteContentStyleResponse, DeleteContentTemplateByIdData, DeleteContentTemplateByIdError, DeleteContentTemplateByIdResponse, DeleteContentVariableData, DeleteContentVariableError, DeleteContentVariableResponse, DeleteContentVariableTypeData, DeleteContentVariableTypeError, DeleteContentVariableTypeResponse, DeleteExperimentData, DeleteExperimentError, DeleteExperimentResponse, DeleteIntegrationData, DeleteIntegrationError, DeleteIntegrationResponse, DeleteWarehouseIdTypeData, DeleteWarehouseIdTypeError, DeleteWarehouseIdTypeResponse, DeleteWarehouseMetricData, DeleteWarehouseMetricError, DeleteWarehouseMetricResponse, DeleteWarehouseSourceTableData, DeleteWarehouseSourceTableError, DeleteWarehouseSourceTableResponse, EnqueueDraftEvaluationData, EnqueueDraftEvaluationError, EnqueueDraftEvaluationResponse, EnqueueDraftGenerationData, EnqueueDraftGenerationError, EnqueueDraftGenerationResponse, EnqueueRegenerateWithFeedbackData, EnqueueRegenerateWithFeedbackError, EnqueueRegenerateWithFeedbackResponse, EnqueueVariantEvaluationData, EnqueueVariantEvaluationError, EnqueueVariantEvaluationResponse, EvaluateMarketingContentData, EvaluateMarketingContentError, EvaluateMarketingContentResponse, ExecuteExperimentMetricData, ExecuteExperimentMetricError, ExecuteExperimentMetricResponse, ExecuteWarehouseMetricTimeseriesData, ExecuteWarehouseMetricTimeseriesError, ExecuteWarehouseMetricTimeseriesResponse, GenerateAdversarialContentData, GenerateAdversarialContentError, GenerateAdversarialContentResponse, GenerateCombinedAdversarialContentData, GenerateCombinedAdversarialContentError, GenerateCombinedAdversarialContentResponse, GenerateData, GenerateError, GenerateResponse2, GenerateSampleTemplateParametersData, GenerateSampleTemplateParametersError, GenerateSampleTemplateParametersResponse, GenerateStreamData, GenerateStreamError, GetActiveStreamData, GetActiveStreamError, GetActiveStreamResponse, GetAppUserData, GetAppUserError, GetAppUserResponse, GetContentAssetData, GetContentAssetError, GetContentAssetResponse, GetContentEvaluationCriteriaByIdData, GetContentEvaluationCriteriaByIdError, GetContentEvaluationCriteriaByIdResponse, GetContentRuleData, GetContentRuleError, GetContentRuleGroupData, GetContentRuleGroupError, GetContentRuleGroupResponse, GetContentRuleResponse, GetContentSchemaByIdData, GetContentSchemaByIdError, GetContentSchemaByIdResponse, GetContentStyleData, GetContentStyleError, GetContentStyleResponse, GetContentTemplateByIdData, GetContentTemplateByIdError, GetContentTemplateByIdResponse, GetContentVariableData, GetContentVariableError, GetContentVariableResponse, GetContentVariableTypeData, GetContentVariableTypeError, GetContentVariableTypeResponse, GetDashboardStatsData, GetDashboardStatsResponse, GetDiagnosticsLogEntryData, GetDiagnosticsLogEntryError, GetDiagnosticsLogEntryResponse, GetDraftData, GetDraftError, GetDraftResponse, GetDynamicImageTemplateData, GetDynamicImageTemplateError, GetDynamicImageTemplateResponse, GetExperimentContextData, GetExperimentContextError, GetExperimentContextResponse, GetExperimentDetailsData, GetExperimentDetailsError, GetExperimentDetailsResponse, GetExperimentExposuresByDayData, GetExperimentExposuresByDayError, GetExperimentExposuresByDayResponse, GetExperimentMetricDailyByVariantData, GetExperimentMetricDailyByVariantError, GetExperimentMetricDailyByVariantResponse, GetExperimentMetricTimeseriesDailyData, GetExperimentMetricTimeseriesDailyError, GetExperimentMetricTimeseriesDailyResponse, GetExperimentVariantEditUrlData, GetExperimentVariantEditUrlError, GetExperimentVariantEditUrlResponse, GetExperimentVariantMetricsData, GetExperimentVariantMetricsResponse, GetExperimentVariantReportData, GetExperimentVariantReportError, GetExperimentVariantReportResponse, GetFeedbackPromptData, GetFeedbackPromptError, GetFeedbackPromptResponse, GetFigmaConvertLogData, GetFigmaConvertLogError, GetFigmaConvertLogResponse, GetFigmaConvertSessionData, GetFigmaConvertSessionError, GetFigmaConvertSessionResponse, GetFigmaConvertStatusData, GetFigmaConvertStatusError, GetFigmaConvertStatusResponse, GetJobData, GetJobError, GetJobResponse, GetReportInsightsAnalysisData, GetReportInsightsAnalysisError, GetReportInsightsAnalysisResponse, GetReportInsightsChartData, GetReportInsightsChartError, GetReportInsightsChartResponse, GetReportInsightsData, GetReportInsightsError, GetReportInsightsHypothesesData, GetReportInsightsHypothesesError, GetReportInsightsHypothesesResponse, GetReportInsightsRecapData, GetReportInsightsRecapError, GetReportInsightsRecapResponse, GetReportInsightsResponse, GetReportInsightsSummaryData, GetReportInsightsSummaryError, GetReportInsightsSummaryResponse, GetSlotEvalOverridesData, GetSlotEvalOverridesError, GetSlotEvalOverridesResponse, GetVariantReportData, GetVariantReportResponse, GetWarehouseFeatureSpecData, GetWarehouseFeatureSpecError, GetWarehouseFeatureSpecResponse, GetWarehouseIdTypeData, GetWarehouseIdTypeError, GetWarehouseIdTypeResponse, GetWarehouseMetricData, GetWarehouseMetricError, GetWarehouseMetricResponse, GetWarehouseSourceTableData, GetWarehouseSourceTableError, GetWarehouseSourceTableResponse, GetWarehouseStoreData, GetWarehouseStoreResponse, HealthLivenessData, HealthReadinessData, HealthReadinessResponse, ImportDynamicImageTemplateAsNeonblueData, ImportDynamicImageTemplateAsNeonblueError, ImportDynamicImageTemplateAsNeonblueResponse, KlaviyoOauthCallbackData, KlaviyoOauthCallbackError, KlaviyoOauthInitiateData, KlaviyoOauthInitiateResponse, ListApiKeysData, ListApiKeysResponse, ListBatchGenerationsData, ListBatchGenerationsError, ListBatchGenerationsResponse, ListChatModelsData, ListChatModelsResponse, ListContentAssetsData, ListContentAssetsError, ListContentAssetsResponse, ListContentEvaluationCriteriaData, ListContentEvaluationCriteriaError, ListContentEvaluationCriteriaResponse, ListContentRuleGroupsData, ListContentRuleGroupsResponse, ListContentRulesData, ListContentRulesResponse, ListContentSchemasData, ListContentSchemasError, ListContentSchemasResponse, ListContentStylesData, ListContentStylesError, ListContentStylesResponse, ListContentTemplatesData, ListContentTemplatesError, ListContentTemplatesResponse, ListContentVariablesData, ListContentVariablesResponse, ListContentVariableTypesData, ListContentVariableTypesError, ListContentVariableTypesResponse, ListDraftGenerationsData, ListDraftGenerationsError, ListDraftGenerationsResponse, ListDraftsData, ListDraftsError, ListDraftsResponse, ListDraftVariantCommentsData, ListDraftVariantCommentsError, ListDraftVariantCommentsResponse, ListDynamicImageFontsData, ListDynamicImageFontsResponse, ListDynamicImageTemplatesData, ListDynamicImageTemplatesError, ListDynamicImageTemplateSlicesData, ListDynamicImageTemplateSlicesError, ListDynamicImageTemplateSlicesResponse, ListDynamicImageTemplatesResponse, ListExperimentFeaturesData, ListExperimentFeaturesResponse, ListExperimentMetricsData, ListExperimentMetricsResponse, ListExperimentMetricsSummaryData, ListExperimentMetricsSummaryError, ListExperimentMetricsSummaryResponse, ListExperimentsData, ListExperimentsError, ListExperimentsResponse, ListExperimentVariantsData, ListExperimentVariantsError, ListExperimentVariantsResponse, ListFigmaConvertRunsData, ListFigmaConvertRunsResponse, ListIntegrationsData, ListIntegrationsResponse, ListJobsData, ListJobsResponse, ListSourceTemplatesData, ListSourceTemplatesError, ListSourceTemplatesResponse, ListSourceTypesData, ListSourceTypesResponse, ListVariablesForTypeData, ListVariablesForTypeError, ListVariablesForTypeResponse, ListWarehouseFeatureSpecsData, ListWarehouseFeatureSpecsError, ListWarehouseFeatureSpecsResponse, ListWarehouseIdTypesData, ListWarehouseIdTypesError, ListWarehouseIdTypesResponse, ListWarehouseMetricsData, ListWarehouseMetricsError, ListWarehouseMetricsResponse, ListWarehouseSourceTablesData, ListWarehouseSourceTablesError, ListWarehouseSourceTablesResponse, PreviewContentTemplateData, PreviewContentTemplateError, PreviewContentTemplateResponse, PreviewWarehouseFeatureData, PreviewWarehouseFeatureError, PreviewWarehouseFeatureResponse, PreviewWarehouseMetricData, PreviewWarehouseMetricError, PreviewWarehouseMetricResponse, PromoteDraftExperimentData, PromoteDraftExperimentError, QueryDiagnosticsLogsData, QueryDiagnosticsLogsError, QueryDiagnosticsLogsResponse, RegenerateDraftVariantData, RegenerateDraftVariantError, RegenerateDraftVariantResponse, RemoveExperimentVariantsData, RemoveExperimentVariantsError, RemoveExperimentVariantsResponse, RemoveSlotSkippedRuleData, RemoveSlotSkippedRuleError, RemoveSlotSkippedRuleResponse, RenderContentTemplateData, RenderContentTemplateError, RenderContentTemplateResponse, ResolveVariableSlugsData, ResolveVariableSlugsError, ResolveVariableSlugsResponse2, ResyncDynamicImageTemplateAsNeonblueData, ResyncDynamicImageTemplateAsNeonblueError, ResyncDynamicImageTemplateAsNeonblueResponse, RootData, RunAdversarialTestData, RunAdversarialTestError, RunAdversarialTestResponse, SaveNeonblueTemplateData, SaveNeonblueTemplateError, SaveNeonblueTemplateResponse, SetDraftCurrentGenerationsData, SetDraftCurrentGenerationsError, SetDraftCurrentGenerationsResponse, SetExperimentStatusData, SetExperimentStatusError, SetExperimentStatusResponse, SetExperimentVariantStatusData, SetExperimentVariantStatusError, SetExperimentVariantStatusResponse, ShopifyInstallData, ShopifyInstallError, ShopifyOauthCallbackData, ShopifyOauthInitiateData, ShopifyOauthInitiateResponse, StreamDiagnosticsLogsData, StreamDiagnosticsLogsError, StreamEvaluationByExperimentData, StreamEvaluationByExperimentError, StreamEvaluationByVariantData, StreamEvaluationByVariantError, StreamFigmaConvertData, StreamFigmaConvertError, StreamGenerationByExperimentData, StreamGenerationByExperimentError, StreamRegenerateByVariantData, StreamRegenerateByVariantError, SyncContentTemplateFromSourceData, SyncContentTemplateFromSourceError, SyncContentTemplateFromSourceResponse, SyncSourceTemplatesData, SyncSourceTemplatesError, SyncSourceTemplatesResponse, UpdateCommentData, UpdateCommentError, UpdateCommentResponse, UpdateCommentStatusData, UpdateCommentStatusError, UpdateCommentStatusResponse, UpdateContentAssetData, UpdateContentAssetError, UpdateContentAssetResponse, UpdateContentEvaluationCriteriaData, UpdateContentEvaluationCriteriaError, UpdateContentEvaluationCriteriaResponse, UpdateContentRuleData, UpdateContentRuleError, UpdateContentRuleGroupData, UpdateContentRuleGroupError, UpdateContentRuleGroupResponse, UpdateContentRuleResponse, UpdateContentSchemaData, UpdateContentSchemaError, UpdateContentSchemaResponse, UpdateContentStyleData, UpdateContentStyleError, UpdateContentStyleResponse, UpdateContentTemplateData, UpdateContentTemplateError, UpdateContentTemplateResponse, UpdateContentVariableData, UpdateContentVariableError, UpdateContentVariableResponse, UpdateContentVariableTypeData, UpdateContentVariableTypeError, UpdateContentVariableTypeResponse, UpdateDraftExperimentData, UpdateDraftExperimentError, UpdateDraftExperimentResponse, UpdateDraftVariantData, UpdateDraftVariantError, UpdateDraftVariantResponse2, UpdateDraftVariantReviewStatusData, UpdateDraftVariantReviewStatusError, UpdateDraftVariantReviewStatusResponse, UpdateExperimentData, UpdateExperimentError, UpdateExperimentResponse, UpdateExperimentVariantsData, UpdateExperimentVariantsError, UpdateExperimentVariantsResponse, UpdateIntegrationData, UpdateIntegrationError, UpdateIntegrationResponse, UpdateWarehouseFeatureSpecData, UpdateWarehouseFeatureSpecError, UpdateWarehouseFeatureSpecResponse, UpdateWarehouseIdTypeData, UpdateWarehouseIdTypeError, UpdateWarehouseIdTypeResponse, UpdateWarehouseMetricData, UpdateWarehouseMetricError, UpdateWarehouseMetricResponse, UpdateWarehouseSourceTableData, UpdateWarehouseSourceTableError, UpdateWarehouseSourceTableResponse, UploadImageData, UploadImageError, UploadImageResponse2 } from '../types.gen';

/**
 * Figma Run
 *
 * Run the managed agent against a Figma design via the shared Figma MCP vault.
 */
export const agentsFigmaRunMutation = (options?: Partial<Options<AgentsFigmaRunData>>): UseMutationOptions<AgentsFigmaRunResponse, AgentsFigmaRunError, Options<AgentsFigmaRunData>> => {
    const mutationOptions: UseMutationOptions<AgentsFigmaRunResponse, AgentsFigmaRunError, Options<AgentsFigmaRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentsFigmaRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'agentsFigmaRun', tags: ['agents'] }
    };
    return mutationOptions;
};

/**
 * Figma Run Stream
 *
 * Run the managed agent against a Figma design, streaming progress over SSE.
 *
 * Emits the normalized SSE protocol: ``progress`` events per Figma MCP tool
 * call / agent message, then a terminal ``complete`` (or ``error``).
 */
export const agentsFigmaRunStreamMutation = (options?: Partial<Options<AgentsFigmaRunStreamData>>): UseMutationOptions<unknown, AgentsFigmaRunStreamError, Options<AgentsFigmaRunStreamData>> => {
    const mutationOptions: UseMutationOptions<unknown, AgentsFigmaRunStreamError, Options<AgentsFigmaRunStreamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentsFigmaRunStream({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'agentsFigmaRunStream', tags: ['agents'] }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listApiKeysQueryKey = (options?: Options<ListApiKeysData>) => createQueryKey('listApiKeys', options, false, ['api-keys']);

/**
 * List Api Keys
 */
export const listApiKeysOptions = (options?: Options<ListApiKeysData>) => queryOptions<ListApiKeysResponse, DefaultError, ListApiKeysResponse, ReturnType<typeof listApiKeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApiKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApiKeysQueryKey(options)
});

/**
 * Create Api Key
 */
export const createApiKeyMutation = (options?: Partial<Options<CreateApiKeyData>>): UseMutationOptions<CreateApiKeyResponse, DefaultError, Options<CreateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<CreateApiKeyResponse, DefaultError, Options<CreateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createApiKey', tags: ['api-keys'] }
    };
    return mutationOptions;
};

/**
 * Delete Api Key
 */
export const deleteApiKeyMutation = (options?: Partial<Options<DeleteApiKeyData>>): UseMutationOptions<DeleteApiKeyResponse, DeleteApiKeyError, Options<DeleteApiKeyData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiKeyResponse, DeleteApiKeyError, Options<DeleteApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteApiKey', tags: ['api-keys'] }
    };
    return mutationOptions;
};

export const getAppUserQueryKey = (options: Options<GetAppUserData>) => createQueryKey('getAppUser', options, false, ['app-users']);

/**
 * Get App User
 */
export const getAppUserOptions = (options: Options<GetAppUserData>) => queryOptions<GetAppUserResponse, GetAppUserError, GetAppUserResponse, ReturnType<typeof getAppUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAppUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAppUserQueryKey(options)
});

export const getDashboardStatsQueryKey = (options?: Options<GetDashboardStatsData>) => createQueryKey('getDashboardStats', options, false, ['dashboard']);

/**
 * Get Dashboard Stats
 */
export const getDashboardStatsOptions = (options?: Options<GetDashboardStatsData>) => queryOptions<GetDashboardStatsResponse, DefaultError, GetDashboardStatsResponse, ReturnType<typeof getDashboardStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboardStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardStatsQueryKey(options)
});

export const listChatModelsQueryKey = (options?: Options<ListChatModelsData>) => createQueryKey('listChatModels', options, false, ['draft-experiments']);

/**
 * List available LLM models for content generation. Call this before configure_draft_slot_generation to show the user their options.
 *
 * List all available chat model identifiers.
 */
export const listChatModelsOptions = (options?: Options<ListChatModelsData>) => queryOptions<ListChatModelsResponse, DefaultError, ListChatModelsResponse, ReturnType<typeof listChatModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChatModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChatModelsQueryKey(options)
});

export const listDraftsQueryKey = (options?: Options<ListDraftsData>) => createQueryKey('listDrafts', options, false, ['draft-experiments']);

/**
 * List all draft experiments with name, status, and variant count
 */
export const listDraftsOptions = (options?: Options<ListDraftsData>) => queryOptions<ListDraftsResponse, ListDraftsError, ListDraftsResponse, ReturnType<typeof listDraftsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDrafts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDraftsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listDraftsInfiniteQueryKey = (options?: Options<ListDraftsData>): QueryKey<Options<ListDraftsData>> => createQueryKey('listDrafts', options, true, ['draft-experiments']);

/**
 * List all draft experiments with name, status, and variant count
 */
export const listDraftsInfiniteOptions = (options?: Options<ListDraftsData>) => infiniteQueryOptions<ListDraftsResponse, ListDraftsError, InfiniteData<ListDraftsResponse>, QueryKey<Options<ListDraftsData>>, number | Pick<QueryKey<Options<ListDraftsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDraftsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDrafts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDraftsInfiniteQueryKey(options)
});

/**
 * Create a new draft experiment with name, hypothesis, and tags
 */
export const createDraftExperimentMutation = (options?: Partial<Options<CreateDraftExperimentData>>): UseMutationOptions<CreateDraftExperimentResponse, CreateDraftExperimentError, Options<CreateDraftExperimentData>> => {
    const mutationOptions: UseMutationOptions<CreateDraftExperimentResponse, CreateDraftExperimentError, Options<CreateDraftExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDraftExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createDraftExperiment', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Evaluate arbitrary content against a rule group via the DAG hard-rules engine.
 */
export const evaluateMarketingContentMutation = (options?: Partial<Options<EvaluateMarketingContentData>>): UseMutationOptions<EvaluateMarketingContentResponse, EvaluateMarketingContentError, Options<EvaluateMarketingContentData>> => {
    const mutationOptions: UseMutationOptions<EvaluateMarketingContentResponse, EvaluateMarketingContentError, Options<EvaluateMarketingContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await evaluateMarketingContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'evaluateMarketingContent', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Generate one violating email per rule, used to seed eval recall tests.
 */
export const generateAdversarialContentMutation = (options?: Partial<Options<GenerateAdversarialContentData>>): UseMutationOptions<GenerateAdversarialContentResponse, GenerateAdversarialContentError, Options<GenerateAdversarialContentData>> => {
    const mutationOptions: UseMutationOptions<GenerateAdversarialContentResponse, GenerateAdversarialContentError, Options<GenerateAdversarialContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateAdversarialContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'generateAdversarialContent', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Generate ONE email designed to violate every selected rule at once.
 */
export const generateCombinedAdversarialContentMutation = (options?: Partial<Options<GenerateCombinedAdversarialContentData>>): UseMutationOptions<GenerateCombinedAdversarialContentResponse, GenerateCombinedAdversarialContentError, Options<GenerateCombinedAdversarialContentData>> => {
    const mutationOptions: UseMutationOptions<GenerateCombinedAdversarialContentResponse, GenerateCombinedAdversarialContentError, Options<GenerateCombinedAdversarialContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateCombinedAdversarialContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'generateCombinedAdversarialContent', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Per-rule recall test: generate violating content, evaluate, report fire/cross-fire.
 */
export const runAdversarialTestMutation = (options?: Partial<Options<RunAdversarialTestData>>): UseMutationOptions<RunAdversarialTestResponse, RunAdversarialTestError, Options<RunAdversarialTestData>> => {
    const mutationOptions: UseMutationOptions<RunAdversarialTestResponse, RunAdversarialTestError, Options<RunAdversarialTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runAdversarialTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'runAdversarialTest', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const streamGenerationByExperimentQueryKey = (options: Options<StreamGenerationByExperimentData>) => createQueryKey('streamGenerationByExperiment', options, false, ['draft-experiments']);

/**
 * SSE stream of generation progress events for a draft experiment
 *
 * Stream generation events for an experiment. Reconnectable via Last-Event-ID.
 */
export const streamGenerationByExperimentOptions = (options: Options<StreamGenerationByExperimentData>) => queryOptions<unknown, StreamGenerationByExperimentError, unknown, ReturnType<typeof streamGenerationByExperimentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamGenerationByExperiment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamGenerationByExperimentQueryKey(options)
});

/**
 * Run generation with SSE streaming of token-by-token progress
 */
export const generateStreamMutation = (options?: Partial<Options<GenerateStreamData>>): UseMutationOptions<unknown, GenerateStreamError, Options<GenerateStreamData>> => {
    const mutationOptions: UseMutationOptions<unknown, GenerateStreamError, Options<GenerateStreamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateStream({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'generateStream', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const streamEvaluationByExperimentQueryKey = (options: Options<StreamEvaluationByExperimentData>) => createQueryKey('streamEvaluationByExperiment', options, false, ['draft-experiments']);

/**
 * SSE stream of evaluation progress events for a draft experiment
 *
 * Stream evaluation events for an experiment. Reconnectable via Last-Event-ID.
 */
export const streamEvaluationByExperimentOptions = (options: Options<StreamEvaluationByExperimentData>) => queryOptions<unknown, StreamEvaluationByExperimentError, unknown, ReturnType<typeof streamEvaluationByExperimentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamEvaluationByExperiment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamEvaluationByExperimentQueryKey(options)
});

export const getActiveStreamQueryKey = (options: Options<GetActiveStreamData>) => createQueryKey('getActiveStream', options, false, ['draft-experiments']);

/**
 * List every currently-running stream for an experiment: generation, evaluation, per-variant evaluation, per-variant regeneration.
 */
export const getActiveStreamOptions = (options: Options<GetActiveStreamData>) => queryOptions<GetActiveStreamResponse, GetActiveStreamError, GetActiveStreamResponse, ReturnType<typeof getActiveStreamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActiveStream({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActiveStreamQueryKey(options)
});

export const getDraftQueryKey = (options: Options<GetDraftData>) => createQueryKey('getDraft', options, false, ['draft-experiments']);

/**
 * Get full draft experiment details including variants, slots, and config
 */
export const getDraftOptions = (options: Options<GetDraftData>) => queryOptions<GetDraftResponse, GetDraftError, GetDraftResponse, ReturnType<typeof getDraftQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDraft({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDraftQueryKey(options)
});

/**
 * Update experiment config: name, variants, content slots, prompt, model
 */
export const updateDraftExperimentMutation = (options?: Partial<Options<UpdateDraftExperimentData>>): UseMutationOptions<UpdateDraftExperimentResponse, UpdateDraftExperimentError, Options<UpdateDraftExperimentData>> => {
    const mutationOptions: UseMutationOptions<UpdateDraftExperimentResponse, UpdateDraftExperimentError, Options<UpdateDraftExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDraftExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateDraftExperiment', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Start async content generation for all axis-based variants at once (variants with personalization variable assignments; hand-authored variants keep their own content). Call this ONCE per experiment, not per variant. Use list_draft_generations to check results after ~20 seconds.
 *
 * Enqueue a generation job and start streaming via GET /{experiment_id}/generate/stream.
 */
export const enqueueDraftGenerationMutation = (options?: Partial<Options<EnqueueDraftGenerationData>>): UseMutationOptions<EnqueueDraftGenerationResponse, EnqueueDraftGenerationError, Options<EnqueueDraftGenerationData>> => {
    const mutationOptions: UseMutationOptions<EnqueueDraftGenerationResponse, EnqueueDraftGenerationError, Options<EnqueueDraftGenerationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueDraftGeneration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'enqueueDraftGeneration', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Run synchronous content generation and return results immediately
 */
export const generateMutation = (options?: Partial<Options<GenerateData>>): UseMutationOptions<GenerateResponse2, GenerateError, Options<GenerateData>> => {
    const mutationOptions: UseMutationOptions<GenerateResponse2, GenerateError, Options<GenerateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'generate', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const listDraftGenerationsQueryKey = (options: Options<ListDraftGenerationsData>) => createQueryKey('listDraftGenerations', options, false, ['draft-experiments']);

/**
 * List all generated content variants for a draft experiment
 */
export const listDraftGenerationsOptions = (options: Options<ListDraftGenerationsData>) => queryOptions<ListDraftGenerationsResponse, ListDraftGenerationsError, ListDraftGenerationsResponse, ReturnType<typeof listDraftGenerationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDraftGenerations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDraftGenerationsQueryKey(options)
});

export const listBatchGenerationsQueryKey = (options: Options<ListBatchGenerationsData>) => createQueryKey('listBatchGenerations', options, false, ['draft-experiments']);

/**
 * List generations from a specific generation batch
 *
 * List all generations in a specific batch.
 */
export const listBatchGenerationsOptions = (options: Options<ListBatchGenerationsData>) => queryOptions<ListBatchGenerationsResponse, ListBatchGenerationsError, ListBatchGenerationsResponse, ReturnType<typeof listBatchGenerationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBatchGenerations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBatchGenerationsQueryKey(options)
});

/**
 * Start async evaluation of ALL current generations against criteria and hard rules. Call ONCE per experiment. Use list_draft_generations to check evaluation_result after ~20 seconds.
 *
 * Enqueue a DAG evaluation job; reuses the existing eval SSE stream.
 */
export const enqueueDraftEvaluationMutation = (options?: Partial<Options<EnqueueDraftEvaluationData>>): UseMutationOptions<EnqueueDraftEvaluationResponse, EnqueueDraftEvaluationError, Options<EnqueueDraftEvaluationData>> => {
    const mutationOptions: UseMutationOptions<EnqueueDraftEvaluationResponse, EnqueueDraftEvaluationError, Options<EnqueueDraftEvaluationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueDraftEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'enqueueDraftEvaluation', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Activate new generations after regenerate_draft_variant. Pass the generation_ids from the regeneration response to make them the current active generations.
 */
export const setDraftCurrentGenerationsMutation = (options?: Partial<Options<SetDraftCurrentGenerationsData>>): UseMutationOptions<SetDraftCurrentGenerationsResponse, SetDraftCurrentGenerationsError, Options<SetDraftCurrentGenerationsData>> => {
    const mutationOptions: UseMutationOptions<SetDraftCurrentGenerationsResponse, SetDraftCurrentGenerationsError, Options<SetDraftCurrentGenerationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDraftCurrentGenerations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'setDraftCurrentGenerations', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const listDraftVariantCommentsQueryKey = (options: Options<ListDraftVariantCommentsData>) => createQueryKey('listDraftVariantComments', options, false, ['draft-experiments']);

/**
 * List review comments on a specific variant. Check existing feedback before regenerating.
 */
export const listDraftVariantCommentsOptions = (options: Options<ListDraftVariantCommentsData>) => queryOptions<ListDraftVariantCommentsResponse, ListDraftVariantCommentsError, ListDraftVariantCommentsResponse, ReturnType<typeof listDraftVariantCommentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDraftVariantComments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDraftVariantCommentsQueryKey(options)
});

/**
 * Add a review comment on a variant without triggering regeneration. Batch comments across variants first, then use regenerate_draft_variant to apply them.
 */
export const createDraftCommentMutation = (options?: Partial<Options<CreateDraftCommentData>>): UseMutationOptions<CreateDraftCommentResponse, CreateDraftCommentError, Options<CreateDraftCommentData>> => {
    const mutationOptions: UseMutationOptions<CreateDraftCommentResponse, CreateDraftCommentError, Options<CreateDraftCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDraftComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createDraftComment', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Delete Comment
 */
export const deleteCommentMutation = (options?: Partial<Options<DeleteCommentData>>): UseMutationOptions<DeleteCommentResponse, DeleteCommentError, Options<DeleteCommentData>> => {
    const mutationOptions: UseMutationOptions<DeleteCommentResponse, DeleteCommentError, Options<DeleteCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteComment', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Edit the text of an existing review comment
 */
export const updateCommentMutation = (options?: Partial<Options<UpdateCommentData>>): UseMutationOptions<UpdateCommentResponse, UpdateCommentError, Options<UpdateCommentData>> => {
    const mutationOptions: UseMutationOptions<UpdateCommentResponse, UpdateCommentError, Options<UpdateCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateComment', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Mark a comment as resolved, pending, or ignored
 */
export const updateCommentStatusMutation = (options?: Partial<Options<UpdateCommentStatusData>>): UseMutationOptions<UpdateCommentStatusResponse, UpdateCommentStatusError, Options<UpdateCommentStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateCommentStatusResponse, UpdateCommentStatusError, Options<UpdateCommentStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCommentStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateCommentStatus', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Add hand-authored variants to a draft experiment, bypassing the LLM generation flow. Each variant supplies content as `value` keyed by slot. Slot keys must match the experiment's content_slots exactly. Each call mints one DraftGenerationBatch shared by all created variants.
 */
export const addDraftVariantsMutation = (options?: Partial<Options<AddDraftVariantsData>>): UseMutationOptions<AddDraftVariantsResponse2, AddDraftVariantsError, Options<AddDraftVariantsData>> => {
    const mutationOptions: UseMutationOptions<AddDraftVariantsResponse2, AddDraftVariantsError, Options<AddDraftVariantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addDraftVariants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'addDraftVariants', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Update a draft variant. Partial update. Send only fields that change. If `value` is supplied, the current generation's value is overwritten in place. evaluation_result is cleared and status is reset to GENERATED.
 */
export const updateDraftVariantMutation = (options?: Partial<Options<UpdateDraftVariantData>>): UseMutationOptions<UpdateDraftVariantResponse2, UpdateDraftVariantError, Options<UpdateDraftVariantData>> => {
    const mutationOptions: UseMutationOptions<UpdateDraftVariantResponse2, UpdateDraftVariantError, Options<UpdateDraftVariantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDraftVariant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateDraftVariant', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Approve or reject a single variant. When all variants are approved, the experiment can be promoted to a live experiment using promote_draft.
 */
export const updateDraftVariantReviewStatusMutation = (options?: Partial<Options<UpdateDraftVariantReviewStatusData>>): UseMutationOptions<UpdateDraftVariantReviewStatusResponse, UpdateDraftVariantReviewStatusError, Options<UpdateDraftVariantReviewStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateDraftVariantReviewStatusResponse, UpdateDraftVariantReviewStatusError, Options<UpdateDraftVariantReviewStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDraftVariantReviewStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateDraftVariantReviewStatus', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Approve or reject multiple variants at once
 *
 * Update review status for multiple variants at once.
 */
export const bulkUpdateReviewStatusMutation = (options?: Partial<Options<BulkUpdateReviewStatusData>>): UseMutationOptions<BulkUpdateReviewStatusResponse, BulkUpdateReviewStatusError, Options<BulkUpdateReviewStatusData>> => {
    const mutationOptions: UseMutationOptions<BulkUpdateReviewStatusResponse, BulkUpdateReviewStatusError, Options<BulkUpdateReviewStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkUpdateReviewStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'bulkUpdateReviewStatus', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Promote a draft experiment to a live experiment. All variants must be approved.
 */
export const promoteDraftExperimentMutation = (options?: Partial<Options<PromoteDraftExperimentData>>): UseMutationOptions<unknown, PromoteDraftExperimentError, Options<PromoteDraftExperimentData>> => {
    const mutationOptions: UseMutationOptions<unknown, PromoteDraftExperimentError, Options<PromoteDraftExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promoteDraftExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'promoteDraftExperiment', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Start async regenerate-with-feedback. Subscribe via GET /regenerate/stream for progress.
 */
export const enqueueRegenerateWithFeedbackMutation = (options?: Partial<Options<EnqueueRegenerateWithFeedbackData>>): UseMutationOptions<EnqueueRegenerateWithFeedbackResponse, EnqueueRegenerateWithFeedbackError, Options<EnqueueRegenerateWithFeedbackData>> => {
    const mutationOptions: UseMutationOptions<EnqueueRegenerateWithFeedbackResponse, EnqueueRegenerateWithFeedbackError, Options<EnqueueRegenerateWithFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueRegenerateWithFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'enqueueRegenerateWithFeedback', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const streamRegenerateByVariantQueryKey = (options: Options<StreamRegenerateByVariantData>) => createQueryKey('streamRegenerateByVariant', options, false, ['draft-experiments']);

/**
 * SSE stream of regenerate-with-feedback progress events
 */
export const streamRegenerateByVariantOptions = (options: Options<StreamRegenerateByVariantData>) => queryOptions<unknown, StreamRegenerateByVariantError, unknown, ReturnType<typeof streamRegenerateByVariantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamRegenerateByVariant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamRegenerateByVariantQueryKey(options)
});

/**
 * Start async DAG evaluation of one variant's current generation. Subscribe via GET /evaluate/stream for progress.
 */
export const enqueueVariantEvaluationMutation = (options?: Partial<Options<EnqueueVariantEvaluationData>>): UseMutationOptions<EnqueueVariantEvaluationResponse, EnqueueVariantEvaluationError, Options<EnqueueVariantEvaluationData>> => {
    const mutationOptions: UseMutationOptions<EnqueueVariantEvaluationResponse, EnqueueVariantEvaluationError, Options<EnqueueVariantEvaluationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueVariantEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'enqueueVariantEvaluation', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const streamEvaluationByVariantQueryKey = (options: Options<StreamEvaluationByVariantData>) => createQueryKey('streamEvaluationByVariant', options, false, ['draft-experiments']);

/**
 * SSE stream of per-variant evaluation progress events
 */
export const streamEvaluationByVariantOptions = (options: Options<StreamEvaluationByVariantData>) => queryOptions<unknown, StreamEvaluationByVariantError, unknown, ReturnType<typeof streamEvaluationByVariantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamEvaluationByVariant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamEvaluationByVariantQueryKey(options)
});

/**
 * Regenerate a variant's content with specific feedback. Returns a new inactive generation. After regenerating, call set_draft_current_generations with the returned generation_ids to activate them.
 *
 * Apply a revision to produce a new (inactive) generation.
 *
 * Phase 2 of the preview → apply → activate flow. The client passes the
 * (possibly edited) CommentBody from the preview step. Returns the
 * new generation value for diff preview.
 *
 * Per-slot 'not a violation' overrides are read from the parent generation's
 * own evaluation_result.slots[*].eval_overrides — the request body does NOT
 * carry a skip list. Mark rules as not-a-violation via the dedicated
 * /generations/{generation_id}/slots/{slot_key}/eval-overrides endpoints.
 */
export const regenerateDraftVariantMutation = (options?: Partial<Options<RegenerateDraftVariantData>>): UseMutationOptions<RegenerateDraftVariantResponse, RegenerateDraftVariantError, Options<RegenerateDraftVariantData>> => {
    const mutationOptions: UseMutationOptions<RegenerateDraftVariantResponse, RegenerateDraftVariantError, Options<RegenerateDraftVariantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await regenerateDraftVariant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'regenerateDraftVariant', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const getSlotEvalOverridesQueryKey = (options: Options<GetSlotEvalOverridesData>) => createQueryKey('getSlotEvalOverrides', options, false, ['draft-experiments']);

/**
 * Read 'not a violation' overrides stored on a specific generation's slot.
 */
export const getSlotEvalOverridesOptions = (options: Options<GetSlotEvalOverridesData>) => queryOptions<GetSlotEvalOverridesResponse, GetSlotEvalOverridesError, GetSlotEvalOverridesResponse, ReturnType<typeof getSlotEvalOverridesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSlotEvalOverrides({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSlotEvalOverridesQueryKey(options)
});

/**
 * Mark a rule as 'not a violation' on this slot. Cascades across every variant's current generation in the experiment so the same rule is skipped everywhere it might fire. Idempotent.
 */
export const addSlotSkippedRuleMutation = (options?: Partial<Options<AddSlotSkippedRuleData>>): UseMutationOptions<AddSlotSkippedRuleResponse, AddSlotSkippedRuleError, Options<AddSlotSkippedRuleData>> => {
    const mutationOptions: UseMutationOptions<AddSlotSkippedRuleResponse, AddSlotSkippedRuleError, Options<AddSlotSkippedRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSlotSkippedRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'addSlotSkippedRule', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

/**
 * Restore a previously-skipped rule. Cascades across every variant's current generation in the experiment to undo the skip everywhere. Idempotent.
 */
export const removeSlotSkippedRuleMutation = (options?: Partial<Options<RemoveSlotSkippedRuleData>>): UseMutationOptions<RemoveSlotSkippedRuleResponse, RemoveSlotSkippedRuleError, Options<RemoveSlotSkippedRuleData>> => {
    const mutationOptions: UseMutationOptions<RemoveSlotSkippedRuleResponse, RemoveSlotSkippedRuleError, Options<RemoveSlotSkippedRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSlotSkippedRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'removeSlotSkippedRule', tags: ['draft-experiments'] }
    };
    return mutationOptions;
};

export const getFeedbackPromptQueryKey = (options: Options<GetFeedbackPromptData>) => createQueryKey('getFeedbackPrompt', options, false, ['draft-experiments']);

/**
 * Get unresolved comments and rule violations for a variant to build feedback
 *
 * Preview a revision: gather unresolved comments + evaluate rules.
 *
 * Returns a unified CommentBody the client can render in a Lexical editor
 * and pass back to regenerate-with-feedback.
 */
export const getFeedbackPromptOptions = (options: Options<GetFeedbackPromptData>) => queryOptions<GetFeedbackPromptResponse, GetFeedbackPromptError, GetFeedbackPromptResponse, ReturnType<typeof getFeedbackPromptQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeedbackPrompt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFeedbackPromptQueryKey(options)
});

/**
 * Render Content Template
 *
 * Render a content template directly by its UUID.
 * Unlike /render (which resolves via a content schema), this endpoint takes
 * the content template ID directly and renders it with the given parameters.
 * Returns the appropriate output type (EmailOutput, PushOutput, etc.)
 * based on the template type.
 */
export const renderContentTemplateMutation = (options?: Partial<Options<RenderContentTemplateData>>): UseMutationOptions<RenderContentTemplateResponse, RenderContentTemplateError, Options<RenderContentTemplateData>> => {
    const mutationOptions: UseMutationOptions<RenderContentTemplateResponse, RenderContentTemplateError, Options<RenderContentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renderContentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'renderContentTemplate', tags: ['render', 'content-templates'] }
    };
    return mutationOptions;
};

export const listContentEvaluationCriteriaQueryKey = (options?: Options<ListContentEvaluationCriteriaData>) => createQueryKey('listContentEvaluationCriteria', options, false, ['content-evaluation-criteria']);

/**
 * List evaluation criteria used to score generated content quality
 */
export const listContentEvaluationCriteriaOptions = (options?: Options<ListContentEvaluationCriteriaData>) => queryOptions<ListContentEvaluationCriteriaResponse, ListContentEvaluationCriteriaError, ListContentEvaluationCriteriaResponse, ReturnType<typeof listContentEvaluationCriteriaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentEvaluationCriteria({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentEvaluationCriteriaQueryKey(options)
});

export const listContentEvaluationCriteriaInfiniteQueryKey = (options?: Options<ListContentEvaluationCriteriaData>): QueryKey<Options<ListContentEvaluationCriteriaData>> => createQueryKey('listContentEvaluationCriteria', options, true, ['content-evaluation-criteria']);

/**
 * List evaluation criteria used to score generated content quality
 */
export const listContentEvaluationCriteriaInfiniteOptions = (options?: Options<ListContentEvaluationCriteriaData>) => infiniteQueryOptions<ListContentEvaluationCriteriaResponse, ListContentEvaluationCriteriaError, InfiniteData<ListContentEvaluationCriteriaResponse>, QueryKey<Options<ListContentEvaluationCriteriaData>>, number | Pick<QueryKey<Options<ListContentEvaluationCriteriaData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContentEvaluationCriteriaData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContentEvaluationCriteria({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentEvaluationCriteriaInfiniteQueryKey(options)
});

/**
 * Create Content Evaluation Criteria
 */
export const createContentEvaluationCriteriaMutation = (options?: Partial<Options<CreateContentEvaluationCriteriaData>>): UseMutationOptions<CreateContentEvaluationCriteriaResponse, CreateContentEvaluationCriteriaError, Options<CreateContentEvaluationCriteriaData>> => {
    const mutationOptions: UseMutationOptions<CreateContentEvaluationCriteriaResponse, CreateContentEvaluationCriteriaError, Options<CreateContentEvaluationCriteriaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentEvaluationCriteria({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentEvaluationCriteria', tags: ['content-evaluation-criteria'] }
    };
    return mutationOptions;
};

/**
 * Delete Content Evaluation Criteria By Id
 */
export const deleteContentEvaluationCriteriaByIdMutation = (options?: Partial<Options<DeleteContentEvaluationCriteriaByIdData>>): UseMutationOptions<DeleteContentEvaluationCriteriaByIdResponse, DeleteContentEvaluationCriteriaByIdError, Options<DeleteContentEvaluationCriteriaByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentEvaluationCriteriaByIdResponse, DeleteContentEvaluationCriteriaByIdError, Options<DeleteContentEvaluationCriteriaByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentEvaluationCriteriaById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentEvaluationCriteriaById', tags: ['content-evaluation-criteria'] }
    };
    return mutationOptions;
};

export const getContentEvaluationCriteriaByIdQueryKey = (options: Options<GetContentEvaluationCriteriaByIdData>) => createQueryKey('getContentEvaluationCriteriaById', options, false, ['content-evaluation-criteria']);

/**
 * Get a specific evaluation criterion's text
 */
export const getContentEvaluationCriteriaByIdOptions = (options: Options<GetContentEvaluationCriteriaByIdData>) => queryOptions<GetContentEvaluationCriteriaByIdResponse, GetContentEvaluationCriteriaByIdError, GetContentEvaluationCriteriaByIdResponse, ReturnType<typeof getContentEvaluationCriteriaByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentEvaluationCriteriaById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentEvaluationCriteriaByIdQueryKey(options)
});

/**
 * Update Content Evaluation Criteria
 */
export const updateContentEvaluationCriteriaMutation = (options?: Partial<Options<UpdateContentEvaluationCriteriaData>>): UseMutationOptions<UpdateContentEvaluationCriteriaResponse, UpdateContentEvaluationCriteriaError, Options<UpdateContentEvaluationCriteriaData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentEvaluationCriteriaResponse, UpdateContentEvaluationCriteriaError, Options<UpdateContentEvaluationCriteriaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentEvaluationCriteria({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentEvaluationCriteria', tags: ['content-evaluation-criteria'] }
    };
    return mutationOptions;
};

export const listContentAssetsQueryKey = (options?: Options<ListContentAssetsData>) => createQueryKey('listContentAssets', options, false, ['content-assets']);

/**
 * List uploaded image assets
 */
export const listContentAssetsOptions = (options?: Options<ListContentAssetsData>) => queryOptions<ListContentAssetsResponse, ListContentAssetsError, ListContentAssetsResponse, ReturnType<typeof listContentAssetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentAssets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentAssetsQueryKey(options)
});

export const listContentAssetsInfiniteQueryKey = (options?: Options<ListContentAssetsData>): QueryKey<Options<ListContentAssetsData>> => createQueryKey('listContentAssets', options, true, ['content-assets']);

/**
 * List uploaded image assets
 */
export const listContentAssetsInfiniteOptions = (options?: Options<ListContentAssetsData>) => infiniteQueryOptions<ListContentAssetsResponse, ListContentAssetsError, InfiniteData<ListContentAssetsResponse>, QueryKey<Options<ListContentAssetsData>>, number | Pick<QueryKey<Options<ListContentAssetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContentAssetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContentAssets({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentAssetsInfiniteQueryKey(options)
});

/**
 * Delete Content Asset
 */
export const deleteContentAssetMutation = (options?: Partial<Options<DeleteContentAssetData>>): UseMutationOptions<DeleteContentAssetResponse, DeleteContentAssetError, Options<DeleteContentAssetData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentAssetResponse, DeleteContentAssetError, Options<DeleteContentAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentAsset', tags: ['content-assets'] }
    };
    return mutationOptions;
};

export const getContentAssetQueryKey = (options: Options<GetContentAssetData>) => createQueryKey('getContentAsset', options, false, ['content-assets']);

/**
 * Get an uploaded image asset by id
 */
export const getContentAssetOptions = (options: Options<GetContentAssetData>) => queryOptions<GetContentAssetResponse, GetContentAssetError, GetContentAssetResponse, ReturnType<typeof getContentAssetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentAsset({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentAssetQueryKey(options)
});

/**
 * Update Content Asset
 */
export const updateContentAssetMutation = (options?: Partial<Options<UpdateContentAssetData>>): UseMutationOptions<UpdateContentAssetResponse, UpdateContentAssetError, Options<UpdateContentAssetData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentAssetResponse, UpdateContentAssetError, Options<UpdateContentAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentAsset', tags: ['content-assets'] }
    };
    return mutationOptions;
};

export const listContentRuleGroupsQueryKey = (options?: Options<ListContentRuleGroupsData>) => createQueryKey('listContentRuleGroups', options, false, ['content-rules']);

/**
 * List rule groups that bundle hard rules for evaluation
 */
export const listContentRuleGroupsOptions = (options?: Options<ListContentRuleGroupsData>) => queryOptions<ListContentRuleGroupsResponse, DefaultError, ListContentRuleGroupsResponse, ReturnType<typeof listContentRuleGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentRuleGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentRuleGroupsQueryKey(options)
});

/**
 * Create a new rule group that bundles hard rules for evaluation
 */
export const createContentRuleGroupMutation = (options?: Partial<Options<CreateContentRuleGroupData>>): UseMutationOptions<CreateContentRuleGroupResponse, CreateContentRuleGroupError, Options<CreateContentRuleGroupData>> => {
    const mutationOptions: UseMutationOptions<CreateContentRuleGroupResponse, CreateContentRuleGroupError, Options<CreateContentRuleGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentRuleGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentRuleGroup', tags: ['content-rules'] }
    };
    return mutationOptions;
};

/**
 * Permanently delete a rule group by id (hard delete)
 */
export const deleteContentRuleGroupMutation = (options?: Partial<Options<DeleteContentRuleGroupData>>): UseMutationOptions<DeleteContentRuleGroupResponse, DeleteContentRuleGroupError, Options<DeleteContentRuleGroupData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentRuleGroupResponse, DeleteContentRuleGroupError, Options<DeleteContentRuleGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentRuleGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentRuleGroup', tags: ['content-rules'] }
    };
    return mutationOptions;
};

export const getContentRuleGroupQueryKey = (options: Options<GetContentRuleGroupData>) => createQueryKey('getContentRuleGroup', options, false, ['content-rules']);

/**
 * Get a rule group with its list of rule IDs
 */
export const getContentRuleGroupOptions = (options: Options<GetContentRuleGroupData>) => queryOptions<GetContentRuleGroupResponse, GetContentRuleGroupError, GetContentRuleGroupResponse, ReturnType<typeof getContentRuleGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentRuleGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentRuleGroupQueryKey(options)
});

/**
 * Update a rule group (rename, edit description, or replace its rule list)
 */
export const updateContentRuleGroupMutation = (options?: Partial<Options<UpdateContentRuleGroupData>>): UseMutationOptions<UpdateContentRuleGroupResponse, UpdateContentRuleGroupError, Options<UpdateContentRuleGroupData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentRuleGroupResponse, UpdateContentRuleGroupError, Options<UpdateContentRuleGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentRuleGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentRuleGroup', tags: ['content-rules'] }
    };
    return mutationOptions;
};

export const listContentRulesQueryKey = (options?: Options<ListContentRulesData>) => createQueryKey('listContentRules', options, false, ['content-rules']);

/**
 * List all hard rules that generated content must follow
 */
export const listContentRulesOptions = (options?: Options<ListContentRulesData>) => queryOptions<ListContentRulesResponse, DefaultError, ListContentRulesResponse, ReturnType<typeof listContentRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentRulesQueryKey(options)
});

/**
 * Create a new hard rule that generated content must follow
 */
export const createContentRuleMutation = (options?: Partial<Options<CreateContentRuleData>>): UseMutationOptions<CreateContentRuleResponse, CreateContentRuleError, Options<CreateContentRuleData>> => {
    const mutationOptions: UseMutationOptions<CreateContentRuleResponse, CreateContentRuleError, Options<CreateContentRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentRule', tags: ['content-rules'] }
    };
    return mutationOptions;
};

/**
 * Permanently delete a hard rule by id (hard delete; cascades from group mappings)
 */
export const deleteContentRuleMutation = (options?: Partial<Options<DeleteContentRuleData>>): UseMutationOptions<DeleteContentRuleResponse, DeleteContentRuleError, Options<DeleteContentRuleData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentRuleResponse, DeleteContentRuleError, Options<DeleteContentRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentRule', tags: ['content-rules'] }
    };
    return mutationOptions;
};

export const getContentRuleQueryKey = (options: Options<GetContentRuleData>) => createQueryKey('getContentRule', options, false, ['content-rules']);

/**
 * Get a specific hard rule's text and group assignments
 */
export const getContentRuleOptions = (options: Options<GetContentRuleData>) => queryOptions<GetContentRuleResponse, GetContentRuleError, GetContentRuleResponse, ReturnType<typeof getContentRuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentRule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentRuleQueryKey(options)
});

/**
 * Update a hard rule's name, text, or group assignments
 */
export const updateContentRuleMutation = (options?: Partial<Options<UpdateContentRuleData>>): UseMutationOptions<UpdateContentRuleResponse, UpdateContentRuleError, Options<UpdateContentRuleData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentRuleResponse, UpdateContentRuleError, Options<UpdateContentRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentRule', tags: ['content-rules'] }
    };
    return mutationOptions;
};

export const listContentSchemasQueryKey = (options?: Options<ListContentSchemasData>) => createQueryKey('listContentSchemas', options, false, ['content-schemas']);

/**
 * List all content schemas that define generation variable structures
 */
export const listContentSchemasOptions = (options?: Options<ListContentSchemasData>) => queryOptions<ListContentSchemasResponse, ListContentSchemasError, ListContentSchemasResponse, ReturnType<typeof listContentSchemasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentSchemas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentSchemasQueryKey(options)
});

export const listContentSchemasInfiniteQueryKey = (options?: Options<ListContentSchemasData>): QueryKey<Options<ListContentSchemasData>> => createQueryKey('listContentSchemas', options, true, ['content-schemas']);

/**
 * List all content schemas that define generation variable structures
 */
export const listContentSchemasInfiniteOptions = (options?: Options<ListContentSchemasData>) => infiniteQueryOptions<ListContentSchemasResponse, ListContentSchemasError, InfiniteData<ListContentSchemasResponse>, QueryKey<Options<ListContentSchemasData>>, number | Pick<QueryKey<Options<ListContentSchemasData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContentSchemasData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContentSchemas({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentSchemasInfiniteQueryKey(options)
});

/**
 * Create Content Schema
 */
export const createContentSchemaMutation = (options?: Partial<Options<CreateContentSchemaData>>): UseMutationOptions<CreateContentSchemaResponse, CreateContentSchemaError, Options<CreateContentSchemaData>> => {
    const mutationOptions: UseMutationOptions<CreateContentSchemaResponse, CreateContentSchemaError, Options<CreateContentSchemaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentSchema({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentSchema', tags: ['content-schemas'] }
    };
    return mutationOptions;
};

/**
 * Delete Content Schema By Id
 */
export const deleteContentSchemaByIdMutation = (options?: Partial<Options<DeleteContentSchemaByIdData>>): UseMutationOptions<DeleteContentSchemaByIdResponse, DeleteContentSchemaByIdError, Options<DeleteContentSchemaByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentSchemaByIdResponse, DeleteContentSchemaByIdError, Options<DeleteContentSchemaByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentSchemaById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentSchemaById', tags: ['content-schemas'] }
    };
    return mutationOptions;
};

export const getContentSchemaByIdQueryKey = (options: Options<GetContentSchemaByIdData>) => createQueryKey('getContentSchemaById', options, false, ['content-schemas']);

/**
 * Get a content schema's JSON schema and linked template
 */
export const getContentSchemaByIdOptions = (options: Options<GetContentSchemaByIdData>) => queryOptions<GetContentSchemaByIdResponse, GetContentSchemaByIdError, GetContentSchemaByIdResponse, ReturnType<typeof getContentSchemaByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentSchemaById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentSchemaByIdQueryKey(options)
});

/**
 * Update Content Schema
 */
export const updateContentSchemaMutation = (options?: Partial<Options<UpdateContentSchemaData>>): UseMutationOptions<UpdateContentSchemaResponse, UpdateContentSchemaError, Options<UpdateContentSchemaData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentSchemaResponse, UpdateContentSchemaError, Options<UpdateContentSchemaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentSchema({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentSchema', tags: ['content-schemas'] }
    };
    return mutationOptions;
};

export const listContentStylesQueryKey = (options?: Options<ListContentStylesData>) => createQueryKey('listContentStyles', options, false, ['content-styles']);

/**
 * List brand voice and tone guidelines for content generation
 */
export const listContentStylesOptions = (options?: Options<ListContentStylesData>) => queryOptions<ListContentStylesResponse, ListContentStylesError, ListContentStylesResponse, ReturnType<typeof listContentStylesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentStyles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentStylesQueryKey(options)
});

export const listContentStylesInfiniteQueryKey = (options?: Options<ListContentStylesData>): QueryKey<Options<ListContentStylesData>> => createQueryKey('listContentStyles', options, true, ['content-styles']);

/**
 * List brand voice and tone guidelines for content generation
 */
export const listContentStylesInfiniteOptions = (options?: Options<ListContentStylesData>) => infiniteQueryOptions<ListContentStylesResponse, ListContentStylesError, InfiniteData<ListContentStylesResponse>, QueryKey<Options<ListContentStylesData>>, number | Pick<QueryKey<Options<ListContentStylesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContentStylesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContentStyles({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentStylesInfiniteQueryKey(options)
});

/**
 * Create a new brand-guide style with a name, guideline text, and output type
 */
export const createContentStyleMutation = (options?: Partial<Options<CreateContentStyleData>>): UseMutationOptions<CreateContentStyleResponse, CreateContentStyleError, Options<CreateContentStyleData>> => {
    const mutationOptions: UseMutationOptions<CreateContentStyleResponse, CreateContentStyleError, Options<CreateContentStyleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentStyle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentStyle', tags: ['content-styles'] }
    };
    return mutationOptions;
};

/**
 * Permanently delete a brand-guide style by id (hard delete)
 */
export const deleteContentStyleMutation = (options?: Partial<Options<DeleteContentStyleData>>): UseMutationOptions<DeleteContentStyleResponse, DeleteContentStyleError, Options<DeleteContentStyleData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentStyleResponse, DeleteContentStyleError, Options<DeleteContentStyleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentStyle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentStyle', tags: ['content-styles'] }
    };
    return mutationOptions;
};

export const getContentStyleQueryKey = (options: Options<GetContentStyleData>) => createQueryKey('getContentStyle', options, false, ['content-styles']);

/**
 * Get a style guideline's full text and output type
 */
export const getContentStyleOptions = (options: Options<GetContentStyleData>) => queryOptions<GetContentStyleResponse, GetContentStyleError, GetContentStyleResponse, ReturnType<typeof getContentStyleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentStyle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentStyleQueryKey(options)
});

/**
 * Update an existing brand-guide style (name, guideline text, or output type)
 */
export const updateContentStyleMutation = (options?: Partial<Options<UpdateContentStyleData>>): UseMutationOptions<UpdateContentStyleResponse, UpdateContentStyleError, Options<UpdateContentStyleData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentStyleResponse, UpdateContentStyleError, Options<UpdateContentStyleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentStyle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentStyle', tags: ['content-styles'] }
    };
    return mutationOptions;
};

export const listContentTemplatesQueryKey = (options?: Options<ListContentTemplatesData>) => createQueryKey('listContentTemplates', options, false, ['content-templates']);

/**
 * List all email/push content templates with type and name
 */
export const listContentTemplatesOptions = (options?: Options<ListContentTemplatesData>) => queryOptions<ListContentTemplatesResponse, ListContentTemplatesError, ListContentTemplatesResponse, ReturnType<typeof listContentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentTemplatesQueryKey(options)
});

export const listContentTemplatesInfiniteQueryKey = (options?: Options<ListContentTemplatesData>): QueryKey<Options<ListContentTemplatesData>> => createQueryKey('listContentTemplates', options, true, ['content-templates']);

/**
 * List all email/push content templates with type and name
 */
export const listContentTemplatesInfiniteOptions = (options?: Options<ListContentTemplatesData>) => infiniteQueryOptions<ListContentTemplatesResponse, ListContentTemplatesError, InfiniteData<ListContentTemplatesResponse>, QueryKey<Options<ListContentTemplatesData>>, number | Pick<QueryKey<Options<ListContentTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContentTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContentTemplates({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentTemplatesInfiniteQueryKey(options)
});

/**
 * Create Content Template
 */
export const createContentTemplateMutation = (options?: Partial<Options<CreateContentTemplateData>>): UseMutationOptions<CreateContentTemplateResponse, CreateContentTemplateError, Options<CreateContentTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateContentTemplateResponse, CreateContentTemplateError, Options<CreateContentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentTemplate', tags: ['content-templates'] }
    };
    return mutationOptions;
};

/**
 * Delete Content Template By Id
 */
export const deleteContentTemplateByIdMutation = (options?: Partial<Options<DeleteContentTemplateByIdData>>): UseMutationOptions<DeleteContentTemplateByIdResponse, DeleteContentTemplateByIdError, Options<DeleteContentTemplateByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentTemplateByIdResponse, DeleteContentTemplateByIdError, Options<DeleteContentTemplateByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentTemplateById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentTemplateById', tags: ['content-templates'] }
    };
    return mutationOptions;
};

export const getContentTemplateByIdQueryKey = (options: Options<GetContentTemplateByIdData>) => createQueryKey('getContentTemplateById', options, false, ['content-templates']);

/**
 * Get a content template's full details including HTML and config
 */
export const getContentTemplateByIdOptions = (options: Options<GetContentTemplateByIdData>) => queryOptions<GetContentTemplateByIdResponse, GetContentTemplateByIdError, GetContentTemplateByIdResponse, ReturnType<typeof getContentTemplateByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentTemplateById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentTemplateByIdQueryKey(options)
});

/**
 * Update Content Template
 */
export const updateContentTemplateMutation = (options?: Partial<Options<UpdateContentTemplateData>>): UseMutationOptions<UpdateContentTemplateResponse, UpdateContentTemplateError, Options<UpdateContentTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentTemplateResponse, UpdateContentTemplateError, Options<UpdateContentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentTemplate', tags: ['content-templates'] }
    };
    return mutationOptions;
};

/**
 * Preview a content template from an external source (Braze/Klaviyo) before importing
 */
export const previewContentTemplateMutation = (options?: Partial<Options<PreviewContentTemplateData>>): UseMutationOptions<PreviewContentTemplateResponse, PreviewContentTemplateError, Options<PreviewContentTemplateData>> => {
    const mutationOptions: UseMutationOptions<PreviewContentTemplateResponse, PreviewContentTemplateError, Options<PreviewContentTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewContentTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'previewContentTemplate', tags: ['content-templates'] }
    };
    return mutationOptions;
};

/**
 * Create or update a native Neon Blue email template
 *
 * Create OR update a Neon Blue email content template. Use this when the user asks to draft, design, edit, or save an email for their experiments.
 *
 * CREATE vs UPDATE:
 * * Omit `template_id` to CREATE a new template (`name` is required).
 * * Pass an existing neonblue template's `template_id` to UPDATE it. Updates are PARTIAL — only the fields you send change; omitted fields keep their current value. Get ids from list_content_templates / get_content_template_by_id.
 *
 * Content — provide EITHER `design_state` (preferred) OR `template_html`:
 * * `design_state` — the visual editor's block tree. Produces a template the user can edit block-by-block; the server renders it to HTML with the editor's own engine. See the design_state field description for the exact shape and supported blocks.
 * * `template_html` — a complete inline-styled HTML email. Faster, but opens as one non-editable block in the editor. Only use if you cannot produce design_state.
 *
 * Embed merge fields as Liquid `{{ nb.<snake_case_name> }}`. Every unique variable auto-registers on the linked content schema — no separate setup.
 *
 * Returns the template's `template_id` and `content_schema_id`.
 */
export const saveNeonblueTemplateMutation = (options?: Partial<Options<SaveNeonblueTemplateData>>): UseMutationOptions<SaveNeonblueTemplateResponse, SaveNeonblueTemplateError, Options<SaveNeonblueTemplateData>> => {
    const mutationOptions: UseMutationOptions<SaveNeonblueTemplateResponse, SaveNeonblueTemplateError, Options<SaveNeonblueTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveNeonblueTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'saveNeonblueTemplate', tags: ['content-templates'] }
    };
    return mutationOptions;
};

/**
 * Sync Content Template From Source
 *
 * Sync a content template from its external source (e.g. Braze, Klaviyo).
 */
export const syncContentTemplateFromSourceMutation = (options?: Partial<Options<SyncContentTemplateFromSourceData>>): UseMutationOptions<SyncContentTemplateFromSourceResponse, SyncContentTemplateFromSourceError, Options<SyncContentTemplateFromSourceData>> => {
    const mutationOptions: UseMutationOptions<SyncContentTemplateFromSourceResponse, SyncContentTemplateFromSourceError, Options<SyncContentTemplateFromSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncContentTemplateFromSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'syncContentTemplateFromSource', tags: ['content-templates'] }
    };
    return mutationOptions;
};

/**
 * Generate sample parameter values for a template using AI
 */
export const generateSampleTemplateParametersMutation = (options?: Partial<Options<GenerateSampleTemplateParametersData>>): UseMutationOptions<GenerateSampleTemplateParametersResponse, GenerateSampleTemplateParametersError, Options<GenerateSampleTemplateParametersData>> => {
    const mutationOptions: UseMutationOptions<GenerateSampleTemplateParametersResponse, GenerateSampleTemplateParametersError, Options<GenerateSampleTemplateParametersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateSampleTemplateParameters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'generateSampleTemplateParameters', tags: ['content-templates'] }
    };
    return mutationOptions;
};

export const listContentVariableTypesQueryKey = (options?: Options<ListContentVariableTypesData>) => createQueryKey('listContentVariableTypes', options, false, ['content-variables']);

/**
 * List variable type definitions (e.g. audience segments, product catalogs)
 */
export const listContentVariableTypesOptions = (options?: Options<ListContentVariableTypesData>) => queryOptions<ListContentVariableTypesResponse, ListContentVariableTypesError, ListContentVariableTypesResponse, ReturnType<typeof listContentVariableTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentVariableTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentVariableTypesQueryKey(options)
});

export const listContentVariableTypesInfiniteQueryKey = (options?: Options<ListContentVariableTypesData>): QueryKey<Options<ListContentVariableTypesData>> => createQueryKey('listContentVariableTypes', options, true, ['content-variables']);

/**
 * List variable type definitions (e.g. audience segments, product catalogs)
 */
export const listContentVariableTypesInfiniteOptions = (options?: Options<ListContentVariableTypesData>) => infiniteQueryOptions<ListContentVariableTypesResponse, ListContentVariableTypesError, InfiniteData<ListContentVariableTypesResponse>, QueryKey<Options<ListContentVariableTypesData>>, number | Pick<QueryKey<Options<ListContentVariableTypesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListContentVariableTypesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listContentVariableTypes({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentVariableTypesInfiniteQueryKey(options)
});

/**
 * Create Content Variable Type
 */
export const createContentVariableTypeMutation = (options?: Partial<Options<CreateContentVariableTypeData>>): UseMutationOptions<CreateContentVariableTypeResponse, CreateContentVariableTypeError, Options<CreateContentVariableTypeData>> => {
    const mutationOptions: UseMutationOptions<CreateContentVariableTypeResponse, CreateContentVariableTypeError, Options<CreateContentVariableTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentVariableType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentVariableType', tags: ['content-variables'] }
    };
    return mutationOptions;
};

/**
 * Delete Content Variable Type
 */
export const deleteContentVariableTypeMutation = (options?: Partial<Options<DeleteContentVariableTypeData>>): UseMutationOptions<DeleteContentVariableTypeResponse, DeleteContentVariableTypeError, Options<DeleteContentVariableTypeData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentVariableTypeResponse, DeleteContentVariableTypeError, Options<DeleteContentVariableTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentVariableType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentVariableType', tags: ['content-variables'] }
    };
    return mutationOptions;
};

export const getContentVariableTypeQueryKey = (options: Options<GetContentVariableTypeData>) => createQueryKey('getContentVariableType', options, false, ['content-variables']);

/**
 * Get a variable type's schema and metadata
 */
export const getContentVariableTypeOptions = (options: Options<GetContentVariableTypeData>) => queryOptions<GetContentVariableTypeResponse, GetContentVariableTypeError, GetContentVariableTypeResponse, ReturnType<typeof getContentVariableTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentVariableType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentVariableTypeQueryKey(options)
});

/**
 * Update Content Variable Type
 */
export const updateContentVariableTypeMutation = (options?: Partial<Options<UpdateContentVariableTypeData>>): UseMutationOptions<UpdateContentVariableTypeResponse, UpdateContentVariableTypeError, Options<UpdateContentVariableTypeData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentVariableTypeResponse, UpdateContentVariableTypeError, Options<UpdateContentVariableTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentVariableType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentVariableType', tags: ['content-variables'] }
    };
    return mutationOptions;
};

export const listVariablesForTypeQueryKey = (options: Options<ListVariablesForTypeData>) => createQueryKey('listVariablesForType', options, false, ['content-variables']);

/**
 * List all variable values within a variable type
 */
export const listVariablesForTypeOptions = (options: Options<ListVariablesForTypeData>) => queryOptions<ListVariablesForTypeResponse, ListVariablesForTypeError, ListVariablesForTypeResponse, ReturnType<typeof listVariablesForTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listVariablesForType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listVariablesForTypeQueryKey(options)
});

/**
 * Bulk Save Variables
 */
export const bulkSaveVariablesMutation = (options?: Partial<Options<BulkSaveVariablesData>>): UseMutationOptions<BulkSaveVariablesResponse, BulkSaveVariablesError, Options<BulkSaveVariablesData>> => {
    const mutationOptions: UseMutationOptions<BulkSaveVariablesResponse, BulkSaveVariablesError, Options<BulkSaveVariablesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkSaveVariables({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'bulkSaveVariables', tags: ['content-variables'] }
    };
    return mutationOptions;
};

export const listContentVariablesQueryKey = (options?: Options<ListContentVariablesData>) => createQueryKey('listContentVariables', options, false, ['content-variables']);

/**
 * List all content variables across types (flat)
 */
export const listContentVariablesOptions = (options?: Options<ListContentVariablesData>) => queryOptions<ListContentVariablesResponse, DefaultError, ListContentVariablesResponse, ReturnType<typeof listContentVariablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentVariables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentVariablesQueryKey(options)
});

/**
 * Create Content Variable
 */
export const createContentVariableMutation = (options?: Partial<Options<CreateContentVariableData>>): UseMutationOptions<CreateContentVariableResponse, CreateContentVariableError, Options<CreateContentVariableData>> => {
    const mutationOptions: UseMutationOptions<CreateContentVariableResponse, CreateContentVariableError, Options<CreateContentVariableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContentVariable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createContentVariable', tags: ['content-variables'] }
    };
    return mutationOptions;
};

/**
 * Delete Content Variable
 */
export const deleteContentVariableMutation = (options?: Partial<Options<DeleteContentVariableData>>): UseMutationOptions<DeleteContentVariableResponse, DeleteContentVariableError, Options<DeleteContentVariableData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentVariableResponse, DeleteContentVariableError, Options<DeleteContentVariableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContentVariable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteContentVariable', tags: ['content-variables'] }
    };
    return mutationOptions;
};

export const getContentVariableQueryKey = (options: Options<GetContentVariableData>) => createQueryKey('getContentVariable', options, false, ['content-variables']);

/**
 * Get a specific variable's value and type
 */
export const getContentVariableOptions = (options: Options<GetContentVariableData>) => queryOptions<GetContentVariableResponse, GetContentVariableError, GetContentVariableResponse, ReturnType<typeof getContentVariableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentVariable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentVariableQueryKey(options)
});

/**
 * Update Content Variable
 */
export const updateContentVariableMutation = (options?: Partial<Options<UpdateContentVariableData>>): UseMutationOptions<UpdateContentVariableResponse, UpdateContentVariableError, Options<UpdateContentVariableData>> => {
    const mutationOptions: UseMutationOptions<UpdateContentVariableResponse, UpdateContentVariableError, Options<UpdateContentVariableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateContentVariable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateContentVariable', tags: ['content-variables'] }
    };
    return mutationOptions;
};

/**
 * Resolve Variable Slugs
 *
 * Resolve variable IDs to slugs. Returns type and variable slug mappings.
 */
export const resolveVariableSlugsMutation = (options?: Partial<Options<ResolveVariableSlugsData>>): UseMutationOptions<ResolveVariableSlugsResponse2, ResolveVariableSlugsError, Options<ResolveVariableSlugsData>> => {
    const mutationOptions: UseMutationOptions<ResolveVariableSlugsResponse2, ResolveVariableSlugsError, Options<ResolveVariableSlugsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveVariableSlugs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'resolveVariableSlugs', tags: ['content-variables'] }
    };
    return mutationOptions;
};

export const listSourceTemplatesQueryKey = (options: Options<ListSourceTemplatesData>) => createQueryKey('listSourceTemplates', options, false, ['source-templates']);

/**
 * List Source Templates
 *
 * List cached source templates for an integration, optionally filtered by source type.
 */
export const listSourceTemplatesOptions = (options: Options<ListSourceTemplatesData>) => queryOptions<ListSourceTemplatesResponse, ListSourceTemplatesError, ListSourceTemplatesResponse, ReturnType<typeof listSourceTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSourceTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSourceTemplatesQueryKey(options)
});

/**
 * Sync Source Templates
 *
 * Start a background job to sync source templates for an integration.
 */
export const syncSourceTemplatesMutation = (options?: Partial<Options<SyncSourceTemplatesData>>): UseMutationOptions<SyncSourceTemplatesResponse, SyncSourceTemplatesError, Options<SyncSourceTemplatesData>> => {
    const mutationOptions: UseMutationOptions<SyncSourceTemplatesResponse, SyncSourceTemplatesError, Options<SyncSourceTemplatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncSourceTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'syncSourceTemplates', tags: ['source-templates'] }
    };
    return mutationOptions;
};

export const listSourceTypesQueryKey = (options?: Options<ListSourceTypesData>) => createQueryKey('listSourceTypes', options, false, ['source-templates']);

/**
 * List Source Types
 *
 * List available source types per integration type.
 */
export const listSourceTypesOptions = (options?: Options<ListSourceTypesData>) => queryOptions<ListSourceTypesResponse, DefaultError, ListSourceTypesResponse, ReturnType<typeof listSourceTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSourceTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSourceTypesQueryKey(options)
});

/**
 * Upload an image and return its public URL
 */
export const uploadImageMutation = (options?: Partial<Options<UploadImageData>>): UseMutationOptions<UploadImageResponse2, UploadImageError, Options<UploadImageData>> => {
    const mutationOptions: UseMutationOptions<UploadImageResponse2, UploadImageError, Options<UploadImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'uploadImage', tags: ['uploads'] }
    };
    return mutationOptions;
};

export const listIntegrationsQueryKey = (options?: Options<ListIntegrationsData>) => createQueryKey('listIntegrations', options, false, ['integrations']);

/**
 * List Integrations
 *
 * List all integrations configured for the current partner.
 */
export const listIntegrationsOptions = (options?: Options<ListIntegrationsData>) => queryOptions<ListIntegrationsResponse, DefaultError, ListIntegrationsResponse, ReturnType<typeof listIntegrationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntegrations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntegrationsQueryKey(options)
});

/**
 * Delete Integration
 *
 * Soft-delete an integration.
 */
export const deleteIntegrationMutation = (options?: Partial<Options<DeleteIntegrationData>>): UseMutationOptions<DeleteIntegrationResponse, DeleteIntegrationError, Options<DeleteIntegrationData>> => {
    const mutationOptions: UseMutationOptions<DeleteIntegrationResponse, DeleteIntegrationError, Options<DeleteIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

/**
 * Update Integration
 *
 * Update an integration's name.
 */
export const updateIntegrationMutation = (options?: Partial<Options<UpdateIntegrationData>>): UseMutationOptions<UpdateIntegrationResponse, UpdateIntegrationError, Options<UpdateIntegrationData>> => {
    const mutationOptions: UseMutationOptions<UpdateIntegrationResponse, UpdateIntegrationError, Options<UpdateIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

/**
 * Create Klaviyo Integration
 *
 * Create a new Klaviyo integration via API key.
 */
export const createKlaviyoIntegrationMutation = (options?: Partial<Options<CreateKlaviyoIntegrationData>>): UseMutationOptions<CreateKlaviyoIntegrationResponse, CreateKlaviyoIntegrationError, Options<CreateKlaviyoIntegrationData>> => {
    const mutationOptions: UseMutationOptions<CreateKlaviyoIntegrationResponse, CreateKlaviyoIntegrationError, Options<CreateKlaviyoIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createKlaviyoIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createKlaviyoIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

/**
 * Klaviyo Oauth Initiate
 *
 * Generate a Klaviyo OAuth authorization URL (PKCE flow).
 */
export const klaviyoOauthInitiateMutation = (options?: Partial<Options<KlaviyoOauthInitiateData>>): UseMutationOptions<KlaviyoOauthInitiateResponse, DefaultError, Options<KlaviyoOauthInitiateData>> => {
    const mutationOptions: UseMutationOptions<KlaviyoOauthInitiateResponse, DefaultError, Options<KlaviyoOauthInitiateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await klaviyoOauthInitiate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'klaviyoOauthInitiate', tags: ['integrations'] }
    };
    return mutationOptions;
};

export const klaviyoOauthCallbackQueryKey = (options?: Options<KlaviyoOauthCallbackData>) => createQueryKey('klaviyoOauthCallback', options, false, ['integrations']);

/**
 * Klaviyo Oauth Callback
 *
 * Handle the Klaviyo OAuth redirect. Exchanges code for tokens and saves the integration.
 */
export const klaviyoOauthCallbackOptions = (options?: Options<KlaviyoOauthCallbackData>) => queryOptions<unknown, KlaviyoOauthCallbackError, unknown, ReturnType<typeof klaviyoOauthCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await klaviyoOauthCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: klaviyoOauthCallbackQueryKey(options)
});

/**
 * Create Braze Integration
 *
 * Create a new Braze integration via API key.
 */
export const createBrazeIntegrationMutation = (options?: Partial<Options<CreateBrazeIntegrationData>>): UseMutationOptions<CreateBrazeIntegrationResponse, CreateBrazeIntegrationError, Options<CreateBrazeIntegrationData>> => {
    const mutationOptions: UseMutationOptions<CreateBrazeIntegrationResponse, CreateBrazeIntegrationError, Options<CreateBrazeIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBrazeIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createBrazeIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

/**
 * Shopify Oauth Initiate
 *
 * Return the partner's Shopify merchant install link.
 *
 * The link is multi-store — the merchant picks which shop to install on
 * after clicking through.
 */
export const shopifyOauthInitiateMutation = (options?: Partial<Options<ShopifyOauthInitiateData>>): UseMutationOptions<ShopifyOauthInitiateResponse, DefaultError, Options<ShopifyOauthInitiateData>> => {
    const mutationOptions: UseMutationOptions<ShopifyOauthInitiateResponse, DefaultError, Options<ShopifyOauthInitiateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shopifyOauthInitiate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'shopifyOauthInitiate', tags: ['integrations'] }
    };
    return mutationOptions;
};

export const shopifyInstallQueryKey = (options: Options<ShopifyInstallData>) => createQueryKey('shopifyInstall', options, false, ['integrations']);

/**
 * Shopify Install
 *
 * Handle Shopify's post-install ping (the partner's ``application_url``).
 *
 * Receives ``shop``/``hmac``/``host``/``timestamp`` (no ``code``). HMAC is
 * signed with the partner's client_secret. On success we kick off Step 2
 * by 3xx-redirecting to ``/admin/oauth/authorize``.
 */
export const shopifyInstallOptions = (options: Options<ShopifyInstallData>) => queryOptions<unknown, ShopifyInstallError, unknown, ReturnType<typeof shopifyInstallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shopifyInstall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shopifyInstallQueryKey(options)
});

export const shopifyOauthCallbackQueryKey = (options?: Options<ShopifyOauthCallbackData>) => createQueryKey('shopifyOauthCallback', options, false, ['integrations']);

/**
 * Shopify Oauth Callback
 *
 * Handle Shopify's authorize redirect.
 *
 * Shared across all partners — partner_id is recovered from the encrypted
 * state set in ``/install``. Verifies state + HMAC, exchanges the code for
 * an offline access token, persists ``ShopifyIntegration``, then redirects
 * to the frontend.
 */
export const shopifyOauthCallbackOptions = (options?: Options<ShopifyOauthCallbackData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof shopifyOauthCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shopifyOauthCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shopifyOauthCallbackQueryKey(options)
});

/**
 * Create Canto Integration
 *
 * Create a Canto integration via client_credentials.
 *
 * Verifies the credentials by minting an access token *before* persisting,
 * so bad creds surface as a 400 on the connect form rather than a silent
 * failure on the next sync.
 */
export const createCantoIntegrationMutation = (options?: Partial<Options<CreateCantoIntegrationData>>): UseMutationOptions<CreateCantoIntegrationResponse, CreateCantoIntegrationError, Options<CreateCantoIntegrationData>> => {
    const mutationOptions: UseMutationOptions<CreateCantoIntegrationResponse, CreateCantoIntegrationError, Options<CreateCantoIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCantoIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createCantoIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

/**
 * Create Klaviyo Dashboard Integration
 *
 * Create a new Klaviyo dashboard integration (username + password + TOTP).
 *
 * Session cookies are harvested lazily on first use, so credentials are
 * not verified here — bad creds surface on the first dashboard call.
 */
export const createKlaviyoDashboardIntegrationMutation = (options?: Partial<Options<CreateKlaviyoDashboardIntegrationData>>): UseMutationOptions<CreateKlaviyoDashboardIntegrationResponse, CreateKlaviyoDashboardIntegrationError, Options<CreateKlaviyoDashboardIntegrationData>> => {
    const mutationOptions: UseMutationOptions<CreateKlaviyoDashboardIntegrationResponse, CreateKlaviyoDashboardIntegrationError, Options<CreateKlaviyoDashboardIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createKlaviyoDashboardIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createKlaviyoDashboardIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

/**
 * Create Dynamic Image Integration
 */
export const createDynamicImageIntegrationMutation = (options?: Partial<Options<CreateDynamicImageIntegrationData>>): UseMutationOptions<CreateDynamicImageIntegrationResponse, CreateDynamicImageIntegrationError, Options<CreateDynamicImageIntegrationData>> => {
    const mutationOptions: UseMutationOptions<CreateDynamicImageIntegrationResponse, CreateDynamicImageIntegrationError, Options<CreateDynamicImageIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDynamicImageIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createDynamicImageIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

export const listDynamicImageTemplatesQueryKey = (options?: Options<ListDynamicImageTemplatesData>) => createQueryKey('listDynamicImageTemplates', options, false, ['integrations']);

/**
 * List Dynamic Image Templates
 */
export const listDynamicImageTemplatesOptions = (options?: Options<ListDynamicImageTemplatesData>) => queryOptions<ListDynamicImageTemplatesResponse, ListDynamicImageTemplatesError, ListDynamicImageTemplatesResponse, ReturnType<typeof listDynamicImageTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDynamicImageTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDynamicImageTemplatesQueryKey(options)
});

export const getDynamicImageTemplateQueryKey = (options: Options<GetDynamicImageTemplateData>) => createQueryKey('getDynamicImageTemplate', options, false, ['integrations']);

/**
 * Get Dynamic Image Template
 */
export const getDynamicImageTemplateOptions = (options: Options<GetDynamicImageTemplateData>) => queryOptions<GetDynamicImageTemplateResponse, GetDynamicImageTemplateError, GetDynamicImageTemplateResponse, ReturnType<typeof getDynamicImageTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDynamicImageTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDynamicImageTemplateQueryKey(options)
});

export const listDynamicImageFontsQueryKey = (options?: Options<ListDynamicImageFontsData>) => createQueryKey('listDynamicImageFonts', options, false, ['integrations']);

/**
 * List Dynamic Image Fonts
 */
export const listDynamicImageFontsOptions = (options?: Options<ListDynamicImageFontsData>) => queryOptions<ListDynamicImageFontsResponse, DefaultError, ListDynamicImageFontsResponse, ReturnType<typeof listDynamicImageFontsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDynamicImageFonts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDynamicImageFontsQueryKey(options)
});

export const listDynamicImageTemplateSlicesQueryKey = (options: Options<ListDynamicImageTemplateSlicesData>) => createQueryKey('listDynamicImageTemplateSlices', options, false, ['integrations']);

/**
 * List Dynamic Image Template Slices
 */
export const listDynamicImageTemplateSlicesOptions = (options: Options<ListDynamicImageTemplateSlicesData>) => queryOptions<ListDynamicImageTemplateSlicesResponse, ListDynamicImageTemplateSlicesError, ListDynamicImageTemplateSlicesResponse, ReturnType<typeof listDynamicImageTemplateSlicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDynamicImageTemplateSlices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDynamicImageTemplateSlicesQueryKey(options)
});

/**
 * Import Dynamic Image Template As Neonblue
 */
export const importDynamicImageTemplateAsNeonblueMutation = (options?: Partial<Options<ImportDynamicImageTemplateAsNeonblueData>>): UseMutationOptions<ImportDynamicImageTemplateAsNeonblueResponse, ImportDynamicImageTemplateAsNeonblueError, Options<ImportDynamicImageTemplateAsNeonblueData>> => {
    const mutationOptions: UseMutationOptions<ImportDynamicImageTemplateAsNeonblueResponse, ImportDynamicImageTemplateAsNeonblueError, Options<ImportDynamicImageTemplateAsNeonblueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importDynamicImageTemplateAsNeonblue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'importDynamicImageTemplateAsNeonblue', tags: ['integrations', 'content-templates'] }
    };
    return mutationOptions;
};

/**
 * Resync Dynamic Image Template As Neonblue
 */
export const resyncDynamicImageTemplateAsNeonblueMutation = (options?: Partial<Options<ResyncDynamicImageTemplateAsNeonblueData>>): UseMutationOptions<ResyncDynamicImageTemplateAsNeonblueResponse, ResyncDynamicImageTemplateAsNeonblueError, Options<ResyncDynamicImageTemplateAsNeonblueData>> => {
    const mutationOptions: UseMutationOptions<ResyncDynamicImageTemplateAsNeonblueResponse, ResyncDynamicImageTemplateAsNeonblueError, Options<ResyncDynamicImageTemplateAsNeonblueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resyncDynamicImageTemplateAsNeonblue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'resyncDynamicImageTemplateAsNeonblue', tags: ['integrations', 'content-templates'] }
    };
    return mutationOptions;
};

/**
 * Convert Dynamic Image Template As Neonblue
 */
export const convertDynamicImageTemplateAsNeonblueMutation = (options?: Partial<Options<ConvertDynamicImageTemplateAsNeonblueData>>): UseMutationOptions<ConvertDynamicImageTemplateAsNeonblueResponse, ConvertDynamicImageTemplateAsNeonblueError, Options<ConvertDynamicImageTemplateAsNeonblueData>> => {
    const mutationOptions: UseMutationOptions<ConvertDynamicImageTemplateAsNeonblueResponse, ConvertDynamicImageTemplateAsNeonblueError, Options<ConvertDynamicImageTemplateAsNeonblueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await convertDynamicImageTemplateAsNeonblue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'convertDynamicImageTemplateAsNeonblue', tags: ['integrations', 'content-templates'] }
    };
    return mutationOptions;
};

/**
 * Convert a Figma email design into a Neon Blue template
 *
 * Starts an asynchronous agent run that converts the Figma design at `figma_url` into a native Neon Blue email template and saves it. Returns a `run_id` immediately; poll `get_figma_convert_status` with that id until `status` is `done` (the response then carries the created `template_id`) or `failed`. Conversions typically take 5 to 20 minutes.
 */
export const convertFigmaUrlToTemplateMutation = (options?: Partial<Options<ConvertFigmaUrlToTemplateData>>): UseMutationOptions<ConvertFigmaUrlToTemplateResponse, ConvertFigmaUrlToTemplateError, Options<ConvertFigmaUrlToTemplateData>> => {
    const mutationOptions: UseMutationOptions<ConvertFigmaUrlToTemplateResponse, ConvertFigmaUrlToTemplateError, Options<ConvertFigmaUrlToTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await convertFigmaUrlToTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'convertFigmaUrlToTemplate', tags: ['integrations', 'content-templates'] }
    };
    return mutationOptions;
};

export const listFigmaConvertRunsQueryKey = (options?: Options<ListFigmaConvertRunsData>) => createQueryKey('listFigmaConvertRuns', options, false, ['integrations']);

/**
 * List recent Figma conversion runs
 *
 * Recent Figma→Neon Blue conversion runs for this organization (most recent first, kept for 2 hours).
 */
export const listFigmaConvertRunsOptions = (options?: Options<ListFigmaConvertRunsData>) => queryOptions<ListFigmaConvertRunsResponse, DefaultError, ListFigmaConvertRunsResponse, ReturnType<typeof listFigmaConvertRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFigmaConvertRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFigmaConvertRunsQueryKey(options)
});

export const getFigmaConvertStatusQueryKey = (options: Options<GetFigmaConvertStatusData>) => createQueryKey('getFigmaConvertStatus', options, false, ['integrations']);

/**
 * Get the status of a Figma conversion run
 *
 * Status of one Figma→Neon Blue conversion run. `status` is queued, running, done (with `template_id`), failed, or error. Runs expire after 2 hours.
 */
export const getFigmaConvertStatusOptions = (options: Options<GetFigmaConvertStatusData>) => queryOptions<GetFigmaConvertStatusResponse, GetFigmaConvertStatusError, GetFigmaConvertStatusResponse, ReturnType<typeof getFigmaConvertStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFigmaConvertStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFigmaConvertStatusQueryKey(options)
});

export const getFigmaConvertLogQueryKey = (options: Options<GetFigmaConvertLogData>) => createQueryKey('getFigmaConvertLog', options, false, ['integrations']);

/**
 * Get Figma Convert Log
 */
export const getFigmaConvertLogOptions = (options: Options<GetFigmaConvertLogData>) => queryOptions<GetFigmaConvertLogResponse, GetFigmaConvertLogError, GetFigmaConvertLogResponse, ReturnType<typeof getFigmaConvertLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFigmaConvertLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFigmaConvertLogQueryKey(options)
});

export const getFigmaConvertSessionQueryKey = (options: Options<GetFigmaConvertSessionData>) => createQueryKey('getFigmaConvertSession', options, false, ['integrations']);

/**
 * Get Figma Convert Session
 */
export const getFigmaConvertSessionOptions = (options: Options<GetFigmaConvertSessionData>) => queryOptions<GetFigmaConvertSessionResponse, GetFigmaConvertSessionError, GetFigmaConvertSessionResponse, ReturnType<typeof getFigmaConvertSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFigmaConvertSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFigmaConvertSessionQueryKey(options)
});

export const streamFigmaConvertQueryKey = (options: Options<StreamFigmaConvertData>) => createQueryKey('streamFigmaConvert', options, false, ['integrations']);

/**
 * Stream Figma Convert
 */
export const streamFigmaConvertOptions = (options: Options<StreamFigmaConvertData>) => queryOptions<unknown, StreamFigmaConvertError, unknown, ReturnType<typeof streamFigmaConvertQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamFigmaConvert({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamFigmaConvertQueryKey(options)
});

/**
 * Create Snowflake Share Outbound Integration
 *
 * Create a new Snowflake outbound data-share integration.
 */
export const createSnowflakeShareOutboundIntegrationMutation = (options?: Partial<Options<CreateSnowflakeShareOutboundIntegrationData>>): UseMutationOptions<CreateSnowflakeShareOutboundIntegrationResponse, CreateSnowflakeShareOutboundIntegrationError, Options<CreateSnowflakeShareOutboundIntegrationData>> => {
    const mutationOptions: UseMutationOptions<CreateSnowflakeShareOutboundIntegrationResponse, CreateSnowflakeShareOutboundIntegrationError, Options<CreateSnowflakeShareOutboundIntegrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSnowflakeShareOutboundIntegration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createSnowflakeShareOutboundIntegration', tags: ['integrations'] }
    };
    return mutationOptions;
};

export const listExperimentFeaturesQueryKey = (options?: Options<ListExperimentFeaturesData>) => createQueryKey('listExperimentFeatures', options, false, ['experiments']);

/**
 * List Experiment Features
 */
export const listExperimentFeaturesOptions = (options?: Options<ListExperimentFeaturesData>) => queryOptions<ListExperimentFeaturesResponse, DefaultError, ListExperimentFeaturesResponse, ReturnType<typeof listExperimentFeaturesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExperimentFeatures({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExperimentFeaturesQueryKey(options)
});

export const listExperimentMetricsQueryKey = (options?: Options<ListExperimentMetricsData>) => createQueryKey('listExperimentMetrics', options, false, ['experiments']);

/**
 * List Experiment Metrics
 */
export const listExperimentMetricsOptions = (options?: Options<ListExperimentMetricsData>) => queryOptions<ListExperimentMetricsResponse, DefaultError, ListExperimentMetricsResponse, ReturnType<typeof listExperimentMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExperimentMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExperimentMetricsQueryKey(options)
});

export const listExperimentsQueryKey = (options?: Options<ListExperimentsData>) => createQueryKey('listExperiments', options, false, ['experiments']);

/**
 * List experiments (live + completed). Filter by `status` to narrow (e.g. 'running'). For per-experiment detail or variant lists use `list_experiment_variants`; for a single variant's edit link use `get_experiment_variant_edit_url`.
 */
export const listExperimentsOptions = (options?: Options<ListExperimentsData>) => queryOptions<ListExperimentsResponse, ListExperimentsError, ListExperimentsResponse, ReturnType<typeof listExperimentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExperiments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExperimentsQueryKey(options)
});

export const listExperimentsInfiniteQueryKey = (options?: Options<ListExperimentsData>): QueryKey<Options<ListExperimentsData>> => createQueryKey('listExperiments', options, true, ['experiments']);

/**
 * List experiments (live + completed). Filter by `status` to narrow (e.g. 'running'). For per-experiment detail or variant lists use `list_experiment_variants`; for a single variant's edit link use `get_experiment_variant_edit_url`.
 */
export const listExperimentsInfiniteOptions = (options?: Options<ListExperimentsData>) => infiniteQueryOptions<ListExperimentsResponse, ListExperimentsError, InfiniteData<ListExperimentsResponse>, QueryKey<Options<ListExperimentsData>>, number | Pick<QueryKey<Options<ListExperimentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListExperimentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listExperiments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExperimentsInfiniteQueryKey(options)
});

/**
 * Create Experiment
 */
export const createExperimentMutation = (options?: Partial<Options<CreateExperimentData>>): UseMutationOptions<CreateExperimentResponse, CreateExperimentError, Options<CreateExperimentData>> => {
    const mutationOptions: UseMutationOptions<CreateExperimentResponse, CreateExperimentError, Options<CreateExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createExperiment', tags: ['experiments'] }
    };
    return mutationOptions;
};

export const getExperimentDetailsQueryKey = (options: Options<GetExperimentDetailsData>) => createQueryKey('getExperimentDetails', options, false, ['experiments']);

/**
 * Get Experiment Details
 */
export const getExperimentDetailsOptions = (options: Options<GetExperimentDetailsData>) => queryOptions<GetExperimentDetailsResponse, GetExperimentDetailsError, GetExperimentDetailsResponse, ReturnType<typeof getExperimentDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentDetailsQueryKey(options)
});

/**
 * Delete Experiment
 */
export const deleteExperimentMutation = (options?: Partial<Options<DeleteExperimentData>>): UseMutationOptions<DeleteExperimentResponse, DeleteExperimentError, Options<DeleteExperimentData>> => {
    const mutationOptions: UseMutationOptions<DeleteExperimentResponse, DeleteExperimentError, Options<DeleteExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteExperiment', tags: ['experiments'] }
    };
    return mutationOptions;
};

/**
 * Update Experiment
 */
export const updateExperimentMutation = (options?: Partial<Options<UpdateExperimentData>>): UseMutationOptions<UpdateExperimentResponse, UpdateExperimentError, Options<UpdateExperimentData>> => {
    const mutationOptions: UseMutationOptions<UpdateExperimentResponse, UpdateExperimentError, Options<UpdateExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateExperiment', tags: ['experiments'] }
    };
    return mutationOptions;
};

/**
 * Set Experiment Status
 */
export const setExperimentStatusMutation = (options?: Partial<Options<SetExperimentStatusData>>): UseMutationOptions<SetExperimentStatusResponse, SetExperimentStatusError, Options<SetExperimentStatusData>> => {
    const mutationOptions: UseMutationOptions<SetExperimentStatusResponse, SetExperimentStatusError, Options<SetExperimentStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setExperimentStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'setExperimentStatus', tags: ['experiments'] }
    };
    return mutationOptions;
};

/**
 * Remove Variants
 */
export const removeExperimentVariantsMutation = (options?: Partial<Options<RemoveExperimentVariantsData>>): UseMutationOptions<RemoveExperimentVariantsResponse, RemoveExperimentVariantsError, Options<RemoveExperimentVariantsData>> => {
    const mutationOptions: UseMutationOptions<RemoveExperimentVariantsResponse, RemoveExperimentVariantsError, Options<RemoveExperimentVariantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeExperimentVariants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'removeExperimentVariants', tags: ['experiments'] }
    };
    return mutationOptions;
};

export const listExperimentVariantsQueryKey = (options: Options<ListExperimentVariantsData>) => createQueryKey('listExperimentVariants', options, false, ['experiments']);

/**
 * List all variants of an experiment with full content. Each item returns variant_id, name, description, status, is_control, tags, edit_url, created_at, and updated_at. It also returns the variant's `template` (per-slot values such as subject, body, h1, cta, preview, plus an optional per-slot content_template_id override), `event_context_filter` (per-variant eligibility filter — which events this variant is allowed to render against), and `action_features` (ML covariates describing the action: channel, persona, lifecycle_stage, includes_discount, is_suppress, etc.). Use this to inspect or compare the actual content and metadata of every variant in an experiment.
 */
export const listExperimentVariantsOptions = (options: Options<ListExperimentVariantsData>) => queryOptions<ListExperimentVariantsResponse, ListExperimentVariantsError, ListExperimentVariantsResponse, ReturnType<typeof listExperimentVariantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExperimentVariants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExperimentVariantsQueryKey(options)
});

/**
 * Update Variants
 */
export const updateExperimentVariantsMutation = (options?: Partial<Options<UpdateExperimentVariantsData>>): UseMutationOptions<UpdateExperimentVariantsResponse, UpdateExperimentVariantsError, Options<UpdateExperimentVariantsData>> => {
    const mutationOptions: UseMutationOptions<UpdateExperimentVariantsResponse, UpdateExperimentVariantsError, Options<UpdateExperimentVariantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExperimentVariants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateExperimentVariants', tags: ['experiments'] }
    };
    return mutationOptions;
};

/**
 * Create Variant
 */
export const createExperimentVariantMutation = (options?: Partial<Options<CreateExperimentVariantData>>): UseMutationOptions<CreateExperimentVariantResponse, CreateExperimentVariantError, Options<CreateExperimentVariantData>> => {
    const mutationOptions: UseMutationOptions<CreateExperimentVariantResponse, CreateExperimentVariantError, Options<CreateExperimentVariantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExperimentVariant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createExperimentVariant', tags: ['experiments'] }
    };
    return mutationOptions;
};

export const getExperimentVariantEditUrlQueryKey = (options: Options<GetExperimentVariantEditUrlData>) => createQueryKey('getExperimentVariantEditUrl', options, false, ['experiments']);

/**
 * Return the portal dashboard URL where a specific experiment variant can be edited. Use this when the user asks to edit, update, or modify a variant — return `edit_url` as a clickable link (absolute URL) so they can navigate to the editor.
 */
export const getExperimentVariantEditUrlOptions = (options: Options<GetExperimentVariantEditUrlData>) => queryOptions<GetExperimentVariantEditUrlResponse, GetExperimentVariantEditUrlError, GetExperimentVariantEditUrlResponse, ReturnType<typeof getExperimentVariantEditUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentVariantEditUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentVariantEditUrlQueryKey(options)
});

/**
 * Set Variant Status
 */
export const setExperimentVariantStatusMutation = (options?: Partial<Options<SetExperimentVariantStatusData>>): UseMutationOptions<SetExperimentVariantStatusResponse, SetExperimentVariantStatusError, Options<SetExperimentVariantStatusData>> => {
    const mutationOptions: UseMutationOptions<SetExperimentVariantStatusResponse, SetExperimentVariantStatusError, Options<SetExperimentVariantStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setExperimentVariantStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'setExperimentVariantStatus', tags: ['experiments'] }
    };
    return mutationOptions;
};

export const getExperimentExposuresByDayQueryKey = (options: Options<GetExperimentExposuresByDayData>) => createQueryKey('getExperimentExposuresByDay', options, false, ['experiments']);

/**
 * Get Exposures By Day
 */
export const getExperimentExposuresByDayOptions = (options: Options<GetExperimentExposuresByDayData>) => queryOptions<GetExperimentExposuresByDayResponse, GetExperimentExposuresByDayError, GetExperimentExposuresByDayResponse, ReturnType<typeof getExperimentExposuresByDayQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentExposuresByDay({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentExposuresByDayQueryKey(options)
});

export const getExperimentMetricTimeseriesDailyQueryKey = (options: Options<GetExperimentMetricTimeseriesDailyData>) => createQueryKey('getExperimentMetricTimeseriesDaily', options, false, ['experiments']);

/**
 * Get Experiment Metric Timeseries Daily
 */
export const getExperimentMetricTimeseriesDailyOptions = (options: Options<GetExperimentMetricTimeseriesDailyData>) => queryOptions<GetExperimentMetricTimeseriesDailyResponse, GetExperimentMetricTimeseriesDailyError, GetExperimentMetricTimeseriesDailyResponse, ReturnType<typeof getExperimentMetricTimeseriesDailyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentMetricTimeseriesDaily({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentMetricTimeseriesDailyQueryKey(options)
});

export const getExperimentMetricDailyByVariantQueryKey = (options: Options<GetExperimentMetricDailyByVariantData>) => createQueryKey('getExperimentMetricDailyByVariant', options, false, ['experiments']);

/**
 * Per-variant daily time series from MD_ tables. Returns daily total_units and sum_unit_value per variant for chart rendering. Requires metric_id query param.
 */
export const getExperimentMetricDailyByVariantOptions = (options: Options<GetExperimentMetricDailyByVariantData>) => queryOptions<GetExperimentMetricDailyByVariantResponse, GetExperimentMetricDailyByVariantError, GetExperimentMetricDailyByVariantResponse, ReturnType<typeof getExperimentMetricDailyByVariantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentMetricDailyByVariant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentMetricDailyByVariantQueryKey(options)
});

export const getExperimentContextQueryKey = (options: Options<GetExperimentContextData>) => createQueryKey('getExperimentContext', options, false, ['experiments']);

/**
 * Analyst-written interpretive context for an experiment: title, audience, intent, metric label, metric explanation, and current read. Returns 404 if no context exists for the experiment.
 */
export const getExperimentContextOptions = (options: Options<GetExperimentContextData>) => queryOptions<GetExperimentContextResponse, GetExperimentContextError, GetExperimentContextResponse, ReturnType<typeof getExperimentContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentContextQueryKey(options)
});

/**
 * Execute a metric query for an experiment. Returns per-variant aggregated stats, bandit_analysis (IPW pairwise comparisons), gate_analysis (pooled treatment vs control contrast), and freshness metadata.
 */
export const executeExperimentMetricMutation = (options?: Partial<Options<ExecuteExperimentMetricData>>): UseMutationOptions<ExecuteExperimentMetricResponse, ExecuteExperimentMetricError, Options<ExecuteExperimentMetricData>> => {
    const mutationOptions: UseMutationOptions<ExecuteExperimentMetricResponse, ExecuteExperimentMetricError, Options<ExecuteExperimentMetricData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeExperimentMetric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'executeExperimentMetric', tags: ['experiments'] }
    };
    return mutationOptions;
};

export const getExperimentVariantReportQueryKey = (options: Options<GetExperimentVariantReportData>) => createQueryKey('getExperimentVariantReport', options, false, ['experiments']);

/**
 * Latest persisted variant report for an experiment (rank, recommendation, peer/evidence stats per variant × metric) plus per-variant Welch contrasts vs control over the latest epoch's window. Use to answer 'how is each variant doing?', 'which variants are leading?', or 'what does the report recommend?'.
 */
export const getExperimentVariantReportOptions = (options: Options<GetExperimentVariantReportData>) => queryOptions<GetExperimentVariantReportResponse, GetExperimentVariantReportError, GetExperimentVariantReportResponse, ReturnType<typeof getExperimentVariantReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentVariantReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentVariantReportQueryKey(options)
});

export const streamDiagnosticsLogsQueryKey = (options: Options<StreamDiagnosticsLogsData>) => createQueryKey('streamDiagnosticsLogs', options, false, ['experiments-diagnostics']);

/**
 * Stream Live Logs
 *
 * SSE endpoint for live log streaming via Redis pub/sub.
 *
 * Streams summary-level data (same shape as the ``/query`` endpoint).
 * The client fetches full details on demand via ``/entry/{stream_id}``.
 * All filtering (variant, assignment type) is done client-side.
 */
export const streamDiagnosticsLogsOptions = (options: Options<StreamDiagnosticsLogsData>) => queryOptions<unknown, StreamDiagnosticsLogsError, unknown, ReturnType<typeof streamDiagnosticsLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamDiagnosticsLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamDiagnosticsLogsQueryKey(options)
});

export const queryDiagnosticsLogsQueryKey = (options: Options<QueryDiagnosticsLogsData>) => createQueryKey('queryDiagnosticsLogs', options, false, ['experiments-diagnostics']);

/**
 * Query Logs
 *
 * Query historical log summaries from the Redis stream.
 *
 * Returns lightweight summaries with ``stream_id`` for detail fetching.
 * All filtering (variant, assignment type) is done client-side.
 */
export const queryDiagnosticsLogsOptions = (options: Options<QueryDiagnosticsLogsData>) => queryOptions<QueryDiagnosticsLogsResponse, QueryDiagnosticsLogsError, QueryDiagnosticsLogsResponse, ReturnType<typeof queryDiagnosticsLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await queryDiagnosticsLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: queryDiagnosticsLogsQueryKey(options)
});

export const queryDiagnosticsLogsInfiniteQueryKey = (options: Options<QueryDiagnosticsLogsData>): QueryKey<Options<QueryDiagnosticsLogsData>> => createQueryKey('queryDiagnosticsLogs', options, true, ['experiments-diagnostics']);

/**
 * Query Logs
 *
 * Query historical log summaries from the Redis stream.
 *
 * Returns lightweight summaries with ``stream_id`` for detail fetching.
 * All filtering (variant, assignment type) is done client-side.
 */
export const queryDiagnosticsLogsInfiniteOptions = (options: Options<QueryDiagnosticsLogsData>) => infiniteQueryOptions<QueryDiagnosticsLogsResponse, QueryDiagnosticsLogsError, InfiniteData<QueryDiagnosticsLogsResponse>, QueryKey<Options<QueryDiagnosticsLogsData>>, string | null | Pick<QueryKey<Options<QueryDiagnosticsLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<QueryDiagnosticsLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await queryDiagnosticsLogs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: queryDiagnosticsLogsInfiniteQueryKey(options)
});

export const getDiagnosticsLogEntryQueryKey = (options: Options<GetDiagnosticsLogEntryData>) => createQueryKey('getDiagnosticsLogEntry', options, false, ['experiments-diagnostics']);

/**
 * Get Log Entry
 *
 * Fetch the full log entry by Redis stream ID.
 */
export const getDiagnosticsLogEntryOptions = (options: Options<GetDiagnosticsLogEntryData>) => queryOptions<GetDiagnosticsLogEntryResponse, GetDiagnosticsLogEntryError, GetDiagnosticsLogEntryResponse, ReturnType<typeof getDiagnosticsLogEntryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDiagnosticsLogEntry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDiagnosticsLogEntryQueryKey(options)
});

export const listJobsQueryKey = (options?: Options<ListJobsData>) => createQueryKey('listJobs', options, false, ['jobs']);

/**
 * List Jobs
 *
 * List all background jobs for the current partner within the result TTL window.
 */
export const listJobsOptions = (options?: Options<ListJobsData>) => queryOptions<ListJobsResponse, DefaultError, ListJobsResponse, ReturnType<typeof listJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listJobsQueryKey(options)
});

export const getJobQueryKey = (options: Options<GetJobData>) => createQueryKey('getJob', options, false, ['jobs']);

/**
 * Get Job
 *
 * Get a single job by ID.
 */
export const getJobOptions = (options: Options<GetJobData>) => queryOptions<GetJobResponse, GetJobError, GetJobResponse, ReturnType<typeof getJobQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJob({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobQueryKey(options)
});

export const listExperimentMetricsSummaryQueryKey = (options?: Options<ListExperimentMetricsSummaryData>) => createQueryKey('listExperimentMetricsSummary', options, false, ['metrics']);

/**
 * List each configured experiment's primary-metric treatment vs control contrast over a date window — one ContrastRow per experiment with lift, p-value, significance, CI half-width, and underpowered flag, plus an experiment-name lookup. Use to answer 'which experiments are winning?' or 'are any experiments underpowered?'.
 */
export const listExperimentMetricsSummaryOptions = (options?: Options<ListExperimentMetricsSummaryData>) => queryOptions<ListExperimentMetricsSummaryResponse, ListExperimentMetricsSummaryError, ListExperimentMetricsSummaryResponse, ReturnType<typeof listExperimentMetricsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExperimentMetricsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExperimentMetricsSummaryQueryKey(options)
});

export const listWarehouseIdTypesQueryKey = (options?: Options<ListWarehouseIdTypesData>) => createQueryKey('listWarehouseIdTypes', options, false, ['warehouse-id-types']);

/**
 * List Id Types
 */
export const listWarehouseIdTypesOptions = (options?: Options<ListWarehouseIdTypesData>) => queryOptions<ListWarehouseIdTypesResponse, ListWarehouseIdTypesError, ListWarehouseIdTypesResponse, ReturnType<typeof listWarehouseIdTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWarehouseIdTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseIdTypesQueryKey(options)
});

export const listWarehouseIdTypesInfiniteQueryKey = (options?: Options<ListWarehouseIdTypesData>): QueryKey<Options<ListWarehouseIdTypesData>> => createQueryKey('listWarehouseIdTypes', options, true, ['warehouse-id-types']);

/**
 * List Id Types
 */
export const listWarehouseIdTypesInfiniteOptions = (options?: Options<ListWarehouseIdTypesData>) => infiniteQueryOptions<ListWarehouseIdTypesResponse, ListWarehouseIdTypesError, InfiniteData<ListWarehouseIdTypesResponse>, QueryKey<Options<ListWarehouseIdTypesData>>, number | Pick<QueryKey<Options<ListWarehouseIdTypesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListWarehouseIdTypesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWarehouseIdTypes({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseIdTypesInfiniteQueryKey(options)
});

/**
 * Create Id Type
 */
export const createWarehouseIdTypeMutation = (options?: Partial<Options<CreateWarehouseIdTypeData>>): UseMutationOptions<CreateWarehouseIdTypeResponse, CreateWarehouseIdTypeError, Options<CreateWarehouseIdTypeData>> => {
    const mutationOptions: UseMutationOptions<CreateWarehouseIdTypeResponse, CreateWarehouseIdTypeError, Options<CreateWarehouseIdTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWarehouseIdType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createWarehouseIdType', tags: ['warehouse-id-types'] }
    };
    return mutationOptions;
};

/**
 * Delete Id Type By Id
 */
export const deleteWarehouseIdTypeMutation = (options?: Partial<Options<DeleteWarehouseIdTypeData>>): UseMutationOptions<DeleteWarehouseIdTypeResponse, DeleteWarehouseIdTypeError, Options<DeleteWarehouseIdTypeData>> => {
    const mutationOptions: UseMutationOptions<DeleteWarehouseIdTypeResponse, DeleteWarehouseIdTypeError, Options<DeleteWarehouseIdTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWarehouseIdType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteWarehouseIdType', tags: ['warehouse-id-types'] }
    };
    return mutationOptions;
};

export const getWarehouseIdTypeQueryKey = (options: Options<GetWarehouseIdTypeData>) => createQueryKey('getWarehouseIdType', options, false, ['warehouse-id-types']);

/**
 * Get Id Type By Id
 */
export const getWarehouseIdTypeOptions = (options: Options<GetWarehouseIdTypeData>) => queryOptions<GetWarehouseIdTypeResponse, GetWarehouseIdTypeError, GetWarehouseIdTypeResponse, ReturnType<typeof getWarehouseIdTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWarehouseIdType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWarehouseIdTypeQueryKey(options)
});

/**
 * Update Id Type
 */
export const updateWarehouseIdTypeMutation = (options?: Partial<Options<UpdateWarehouseIdTypeData>>): UseMutationOptions<UpdateWarehouseIdTypeResponse, UpdateWarehouseIdTypeError, Options<UpdateWarehouseIdTypeData>> => {
    const mutationOptions: UseMutationOptions<UpdateWarehouseIdTypeResponse, UpdateWarehouseIdTypeError, Options<UpdateWarehouseIdTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWarehouseIdType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateWarehouseIdType', tags: ['warehouse-id-types'] }
    };
    return mutationOptions;
};

export const listWarehouseSourceTablesQueryKey = (options?: Options<ListWarehouseSourceTablesData>) => createQueryKey('listWarehouseSourceTables', options, false, ['warehouse-source-tables']);

/**
 * List Source Tables
 */
export const listWarehouseSourceTablesOptions = (options?: Options<ListWarehouseSourceTablesData>) => queryOptions<ListWarehouseSourceTablesResponse, ListWarehouseSourceTablesError, ListWarehouseSourceTablesResponse, ReturnType<typeof listWarehouseSourceTablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWarehouseSourceTables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseSourceTablesQueryKey(options)
});

export const listWarehouseSourceTablesInfiniteQueryKey = (options?: Options<ListWarehouseSourceTablesData>): QueryKey<Options<ListWarehouseSourceTablesData>> => createQueryKey('listWarehouseSourceTables', options, true, ['warehouse-source-tables']);

/**
 * List Source Tables
 */
export const listWarehouseSourceTablesInfiniteOptions = (options?: Options<ListWarehouseSourceTablesData>) => infiniteQueryOptions<ListWarehouseSourceTablesResponse, ListWarehouseSourceTablesError, InfiniteData<ListWarehouseSourceTablesResponse>, QueryKey<Options<ListWarehouseSourceTablesData>>, number | Pick<QueryKey<Options<ListWarehouseSourceTablesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListWarehouseSourceTablesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWarehouseSourceTables({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseSourceTablesInfiniteQueryKey(options)
});

/**
 * Create Source Table
 */
export const createWarehouseSourceTableMutation = (options?: Partial<Options<CreateWarehouseSourceTableData>>): UseMutationOptions<CreateWarehouseSourceTableResponse, CreateWarehouseSourceTableError, Options<CreateWarehouseSourceTableData>> => {
    const mutationOptions: UseMutationOptions<CreateWarehouseSourceTableResponse, CreateWarehouseSourceTableError, Options<CreateWarehouseSourceTableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWarehouseSourceTable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createWarehouseSourceTable', tags: ['warehouse-source-tables'] }
    };
    return mutationOptions;
};

/**
 * Delete Source Table By Id
 */
export const deleteWarehouseSourceTableMutation = (options?: Partial<Options<DeleteWarehouseSourceTableData>>): UseMutationOptions<DeleteWarehouseSourceTableResponse, DeleteWarehouseSourceTableError, Options<DeleteWarehouseSourceTableData>> => {
    const mutationOptions: UseMutationOptions<DeleteWarehouseSourceTableResponse, DeleteWarehouseSourceTableError, Options<DeleteWarehouseSourceTableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWarehouseSourceTable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteWarehouseSourceTable', tags: ['warehouse-source-tables'] }
    };
    return mutationOptions;
};

export const getWarehouseSourceTableQueryKey = (options: Options<GetWarehouseSourceTableData>) => createQueryKey('getWarehouseSourceTable', options, false, ['warehouse-source-tables']);

/**
 * Get Source Table By Id
 */
export const getWarehouseSourceTableOptions = (options: Options<GetWarehouseSourceTableData>) => queryOptions<GetWarehouseSourceTableResponse, GetWarehouseSourceTableError, GetWarehouseSourceTableResponse, ReturnType<typeof getWarehouseSourceTableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWarehouseSourceTable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWarehouseSourceTableQueryKey(options)
});

/**
 * Update Source Table
 */
export const updateWarehouseSourceTableMutation = (options?: Partial<Options<UpdateWarehouseSourceTableData>>): UseMutationOptions<UpdateWarehouseSourceTableResponse, UpdateWarehouseSourceTableError, Options<UpdateWarehouseSourceTableData>> => {
    const mutationOptions: UseMutationOptions<UpdateWarehouseSourceTableResponse, UpdateWarehouseSourceTableError, Options<UpdateWarehouseSourceTableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWarehouseSourceTable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateWarehouseSourceTable', tags: ['warehouse-source-tables'] }
    };
    return mutationOptions;
};

export const listWarehouseFeatureSpecsQueryKey = (options?: Options<ListWarehouseFeatureSpecsData>) => createQueryKey('listWarehouseFeatureSpecs', options, false, ['warehouse-features']);

/**
 * List Feature Specs
 */
export const listWarehouseFeatureSpecsOptions = (options?: Options<ListWarehouseFeatureSpecsData>) => queryOptions<ListWarehouseFeatureSpecsResponse, ListWarehouseFeatureSpecsError, ListWarehouseFeatureSpecsResponse, ReturnType<typeof listWarehouseFeatureSpecsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWarehouseFeatureSpecs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseFeatureSpecsQueryKey(options)
});

export const listWarehouseFeatureSpecsInfiniteQueryKey = (options?: Options<ListWarehouseFeatureSpecsData>): QueryKey<Options<ListWarehouseFeatureSpecsData>> => createQueryKey('listWarehouseFeatureSpecs', options, true, ['warehouse-features']);

/**
 * List Feature Specs
 */
export const listWarehouseFeatureSpecsInfiniteOptions = (options?: Options<ListWarehouseFeatureSpecsData>) => infiniteQueryOptions<ListWarehouseFeatureSpecsResponse, ListWarehouseFeatureSpecsError, InfiniteData<ListWarehouseFeatureSpecsResponse>, QueryKey<Options<ListWarehouseFeatureSpecsData>>, number | Pick<QueryKey<Options<ListWarehouseFeatureSpecsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListWarehouseFeatureSpecsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWarehouseFeatureSpecs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseFeatureSpecsInfiniteQueryKey(options)
});

/**
 * Create Feature Spec
 */
export const createWarehouseFeatureSpecMutation = (options?: Partial<Options<CreateWarehouseFeatureSpecData>>): UseMutationOptions<CreateWarehouseFeatureSpecResponse, CreateWarehouseFeatureSpecError, Options<CreateWarehouseFeatureSpecData>> => {
    const mutationOptions: UseMutationOptions<CreateWarehouseFeatureSpecResponse, CreateWarehouseFeatureSpecError, Options<CreateWarehouseFeatureSpecData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWarehouseFeatureSpec({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createWarehouseFeatureSpec', tags: ['warehouse-features'] }
    };
    return mutationOptions;
};

export const getWarehouseStoreQueryKey = (options?: Options<GetWarehouseStoreData>) => createQueryKey('getWarehouseStore', options, false, ['warehouse-features']);

/**
 * Get Feature Store
 */
export const getWarehouseStoreOptions = (options?: Options<GetWarehouseStoreData>) => queryOptions<GetWarehouseStoreResponse, DefaultError, GetWarehouseStoreResponse, ReturnType<typeof getWarehouseStoreQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWarehouseStore({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWarehouseStoreQueryKey(options)
});

/**
 * Preview Feature Query
 */
export const previewWarehouseFeatureMutation = (options?: Partial<Options<PreviewWarehouseFeatureData>>): UseMutationOptions<PreviewWarehouseFeatureResponse, PreviewWarehouseFeatureError, Options<PreviewWarehouseFeatureData>> => {
    const mutationOptions: UseMutationOptions<PreviewWarehouseFeatureResponse, PreviewWarehouseFeatureError, Options<PreviewWarehouseFeatureData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewWarehouseFeature({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'previewWarehouseFeature', tags: ['warehouse-features'] }
    };
    return mutationOptions;
};

export const getWarehouseFeatureSpecQueryKey = (options: Options<GetWarehouseFeatureSpecData>) => createQueryKey('getWarehouseFeatureSpec', options, false, ['warehouse-features']);

/**
 * Get Feature Spec
 */
export const getWarehouseFeatureSpecOptions = (options: Options<GetWarehouseFeatureSpecData>) => queryOptions<GetWarehouseFeatureSpecResponse, GetWarehouseFeatureSpecError, GetWarehouseFeatureSpecResponse, ReturnType<typeof getWarehouseFeatureSpecQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWarehouseFeatureSpec({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWarehouseFeatureSpecQueryKey(options)
});

/**
 * Update Feature Spec
 */
export const updateWarehouseFeatureSpecMutation = (options?: Partial<Options<UpdateWarehouseFeatureSpecData>>): UseMutationOptions<UpdateWarehouseFeatureSpecResponse, UpdateWarehouseFeatureSpecError, Options<UpdateWarehouseFeatureSpecData>> => {
    const mutationOptions: UseMutationOptions<UpdateWarehouseFeatureSpecResponse, UpdateWarehouseFeatureSpecError, Options<UpdateWarehouseFeatureSpecData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWarehouseFeatureSpec({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateWarehouseFeatureSpec', tags: ['warehouse-features'] }
    };
    return mutationOptions;
};

/**
 * Preview Metric Query
 */
export const previewWarehouseMetricMutation = (options?: Partial<Options<PreviewWarehouseMetricData>>): UseMutationOptions<PreviewWarehouseMetricResponse, PreviewWarehouseMetricError, Options<PreviewWarehouseMetricData>> => {
    const mutationOptions: UseMutationOptions<PreviewWarehouseMetricResponse, PreviewWarehouseMetricError, Options<PreviewWarehouseMetricData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewWarehouseMetric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'previewWarehouseMetric', tags: ['warehouse-metrics'] }
    };
    return mutationOptions;
};

/**
 * Execute Metric Timeseries
 */
export const executeWarehouseMetricTimeseriesMutation = (options?: Partial<Options<ExecuteWarehouseMetricTimeseriesData>>): UseMutationOptions<ExecuteWarehouseMetricTimeseriesResponse, ExecuteWarehouseMetricTimeseriesError, Options<ExecuteWarehouseMetricTimeseriesData>> => {
    const mutationOptions: UseMutationOptions<ExecuteWarehouseMetricTimeseriesResponse, ExecuteWarehouseMetricTimeseriesError, Options<ExecuteWarehouseMetricTimeseriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeWarehouseMetricTimeseries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'executeWarehouseMetricTimeseries', tags: ['warehouse-metrics'] }
    };
    return mutationOptions;
};

export const listWarehouseMetricsQueryKey = (options?: Options<ListWarehouseMetricsData>) => createQueryKey('listWarehouseMetrics', options, false, ['warehouse-metrics']);

/**
 * List Metrics
 */
export const listWarehouseMetricsOptions = (options?: Options<ListWarehouseMetricsData>) => queryOptions<ListWarehouseMetricsResponse, ListWarehouseMetricsError, ListWarehouseMetricsResponse, ReturnType<typeof listWarehouseMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWarehouseMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseMetricsQueryKey(options)
});

export const listWarehouseMetricsInfiniteQueryKey = (options?: Options<ListWarehouseMetricsData>): QueryKey<Options<ListWarehouseMetricsData>> => createQueryKey('listWarehouseMetrics', options, true, ['warehouse-metrics']);

/**
 * List Metrics
 */
export const listWarehouseMetricsInfiniteOptions = (options?: Options<ListWarehouseMetricsData>) => infiniteQueryOptions<ListWarehouseMetricsResponse, ListWarehouseMetricsError, InfiniteData<ListWarehouseMetricsResponse>, QueryKey<Options<ListWarehouseMetricsData>>, number | Pick<QueryKey<Options<ListWarehouseMetricsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListWarehouseMetricsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWarehouseMetrics({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWarehouseMetricsInfiniteQueryKey(options)
});

/**
 * Create Metric
 */
export const createWarehouseMetricMutation = (options?: Partial<Options<CreateWarehouseMetricData>>): UseMutationOptions<CreateWarehouseMetricResponse, CreateWarehouseMetricError, Options<CreateWarehouseMetricData>> => {
    const mutationOptions: UseMutationOptions<CreateWarehouseMetricResponse, CreateWarehouseMetricError, Options<CreateWarehouseMetricData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWarehouseMetric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'createWarehouseMetric', tags: ['warehouse-metrics'] }
    };
    return mutationOptions;
};

/**
 * Delete Metric By Id
 */
export const deleteWarehouseMetricMutation = (options?: Partial<Options<DeleteWarehouseMetricData>>): UseMutationOptions<DeleteWarehouseMetricResponse, DeleteWarehouseMetricError, Options<DeleteWarehouseMetricData>> => {
    const mutationOptions: UseMutationOptions<DeleteWarehouseMetricResponse, DeleteWarehouseMetricError, Options<DeleteWarehouseMetricData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWarehouseMetric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'deleteWarehouseMetric', tags: ['warehouse-metrics'] }
    };
    return mutationOptions;
};

export const getWarehouseMetricQueryKey = (options: Options<GetWarehouseMetricData>) => createQueryKey('getWarehouseMetric', options, false, ['warehouse-metrics']);

/**
 * Get Metric By Id
 */
export const getWarehouseMetricOptions = (options: Options<GetWarehouseMetricData>) => queryOptions<GetWarehouseMetricResponse, GetWarehouseMetricError, GetWarehouseMetricResponse, ReturnType<typeof getWarehouseMetricQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWarehouseMetric({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWarehouseMetricQueryKey(options)
});

/**
 * Update Metric
 */
export const updateWarehouseMetricMutation = (options?: Partial<Options<UpdateWarehouseMetricData>>): UseMutationOptions<UpdateWarehouseMetricResponse, UpdateWarehouseMetricError, Options<UpdateWarehouseMetricData>> => {
    const mutationOptions: UseMutationOptions<UpdateWarehouseMetricResponse, UpdateWarehouseMetricError, Options<UpdateWarehouseMetricData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWarehouseMetric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        },
        meta: { operationId: 'updateWarehouseMetric', tags: ['warehouse-metrics'] }
    };
    return mutationOptions;
};

export const getReportInsightsRecapQueryKey = (options: Options<GetReportInsightsRecapData>) => createQueryKey('getReportInsightsRecap', options, false, ['report-insights']);

/**
 * 4-sentence experiment recap: audience, design, result, takeaway. 3-5 LLM calls.
 */
export const getReportInsightsRecapOptions = (options: Options<GetReportInsightsRecapData>) => queryOptions<GetReportInsightsRecapResponse, GetReportInsightsRecapError, GetReportInsightsRecapResponse, ReturnType<typeof getReportInsightsRecapQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportInsightsRecap({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportInsightsRecapQueryKey(options)
});

export const getReportInsightsChartQueryKey = (options: Options<GetReportInsightsChartData>) => createQueryKey('getReportInsightsChart', options, false, ['report-insights']);

/**
 * Variant status and metric data (included in /insights). Fast, no LLM calls.
 */
export const getReportInsightsChartOptions = (options: Options<GetReportInsightsChartData>) => queryOptions<GetReportInsightsChartResponse, GetReportInsightsChartError, GetReportInsightsChartResponse, ReturnType<typeof getReportInsightsChartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportInsightsChart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportInsightsChartQueryKey(options)
});

export const getReportInsightsSummaryQueryKey = (options: Options<GetReportInsightsSummaryData>) => createQueryKey('getReportInsightsSummary', options, false, ['report-insights']);

/**
 * Executive summary only (included in /insights). One LLM call.
 */
export const getReportInsightsSummaryOptions = (options: Options<GetReportInsightsSummaryData>) => queryOptions<GetReportInsightsSummaryResponse, GetReportInsightsSummaryError, GetReportInsightsSummaryResponse, ReturnType<typeof getReportInsightsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportInsightsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportInsightsSummaryQueryKey(options)
});

export const getReportInsightsAnalysisQueryKey = (options: Options<GetReportInsightsAnalysisData>) => createQueryKey('getReportInsightsAnalysis', options, false, ['report-insights']);

/**
 * Content pattern analysis only (included in /insights). One LLM call.
 */
export const getReportInsightsAnalysisOptions = (options: Options<GetReportInsightsAnalysisData>) => queryOptions<GetReportInsightsAnalysisResponse, GetReportInsightsAnalysisError, GetReportInsightsAnalysisResponse, ReturnType<typeof getReportInsightsAnalysisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportInsightsAnalysis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportInsightsAnalysisQueryKey(options)
});

export const getReportInsightsHypothesesQueryKey = (options: Options<GetReportInsightsHypothesesData>) => createQueryKey('getReportInsightsHypotheses', options, false, ['report-insights']);

/**
 * Testable hypotheses only (included in /insights). Runs analysis first, then two more LLM calls.
 */
export const getReportInsightsHypothesesOptions = (options: Options<GetReportInsightsHypothesesData>) => queryOptions<GetReportInsightsHypothesesResponse, GetReportInsightsHypothesesError, GetReportInsightsHypothesesResponse, ReturnType<typeof getReportInsightsHypothesesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportInsightsHypotheses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportInsightsHypothesesQueryKey(options)
});

export const getReportInsightsQueryKey = (options: Options<GetReportInsightsData>) => createQueryKey('getReportInsights', options, false, ['report-insights']);

/**
 * Full report insights — use this unless you only need one section. Runs chart + summary + analysis + hypotheses in parallel where possible.
 */
export const getReportInsightsOptions = (options: Options<GetReportInsightsData>) => queryOptions<GetReportInsightsResponse, GetReportInsightsError, GetReportInsightsResponse, ReturnType<typeof getReportInsightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReportInsights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReportInsightsQueryKey(options)
});

export const getVariantReportQueryKey = (options?: Options<GetVariantReportData>) => createQueryKey('getVariantReport', options, false, ['experiments']);

/**
 * Treatment effects and variant rankings for coterie flow-split experiments
 */
export const getVariantReportOptions = (options?: Options<GetVariantReportData>) => queryOptions<GetVariantReportResponse, DefaultError, GetVariantReportResponse, ReturnType<typeof getVariantReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVariantReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVariantReportQueryKey(options)
});

export const getExperimentVariantMetricsQueryKey = (options?: Options<GetExperimentVariantMetricsData>) => createQueryKey('getExperimentVariantMetrics', options, false, ['experiments']);

/**
 * Treatment effects and variant rankings from E_KLAVIYO_FLOW_SPLIT_EVALUATIONS
 */
export const getExperimentVariantMetricsOptions = (options?: Options<GetExperimentVariantMetricsData>) => queryOptions<GetExperimentVariantMetricsResponse, DefaultError, GetExperimentVariantMetricsResponse, ReturnType<typeof getExperimentVariantMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentVariantMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentVariantMetricsQueryKey(options)
});

export const rootQueryKey = (options?: Options<RootData>) => createQueryKey('root', options, false, ['meta']);

/**
 * Root
 *
 * Root endpoint.
 */
export const rootOptions = (options?: Options<RootData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof rootQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await root({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rootQueryKey(options)
});

export const healthLivenessQueryKey = (options?: Options<HealthLivenessData>) => createQueryKey('healthLiveness', options, false, ['health']);

/**
 * Liveness
 *
 * Liveness probe - checks if the service is running.
 */
export const healthLivenessOptions = (options?: Options<HealthLivenessData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof healthLivenessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthLiveness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthLivenessQueryKey(options)
});

export const healthReadinessQueryKey = (options?: Options<HealthReadinessData>) => createQueryKey('healthReadiness', options, false, ['health']);

/**
 * Readiness
 *
 * Readiness probe — checks DB connectivity for every partner.
 *
 * Returns 200 if all checks pass, 503 if any critical check fails.
 * Does NOT require authentication (K8s probes).
 */
export const healthReadinessOptions = (options?: Options<HealthReadinessData>) => queryOptions<HealthReadinessResponse, DefaultError, HealthReadinessResponse, ReturnType<typeof healthReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthReadinessQueryKey(options)
});
